module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "Blurb"
  }, [_vm._v("Ellis Janzon is a retired Assistant Professor and academic teacher in public health who now lives near the sea and forest. Nature inspired the writing of this book. It aims to develop young children’s understandings about the joy of being in nature and inspiring them by what it has to offer. It also aims to teach children about healthy eating and showing kindness to all animals. Most of all, this book hopes to spread joy, and that by reading to their child, the reader and child build joyful memories together.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035835188_txt2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035835188_txt3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "Heading ParaOverride-1"
  }, [_vm._v("Copyright © Ellis Janzon 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_vm._v("The right of "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Ellis Janzon ")]), _vm._v("to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_vm._v("ISBN 9781035835188 (Paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_vm._v("ISBN 9781035835195 (ePub e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("www.austinmacauley.com")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_vm._v("First Published 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Austin Macauley Publishers Ltd"), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("®")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("1 Canada Square ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Canary Wharf ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("E14 5AA")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "Dedi ParaOverride-3"
  }, [_vm._v("To my grown son with a smile back in time.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Thank you to my friends and family members, my-brother-in-law David Hill, former naval pilot and to David’s daughter Claire Hill, working in university administration, who together undertook the language revision since English is their mother tongue.")])]), _vm._v(" "), _c('p', {
    staticClass: "New-Heading-1"
  }, [_vm._v("Table of Content")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-5"
  }, [_c('span', {
    staticClass: "Hyperlink CharOverride-4"
  }, [_vm._v("Preface")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-5"
  }, [_c('span', {
    staticClass: "Hyperlink CharOverride-4"
  }, [_vm._v("1. The Singing- Trolls and Their World")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-5"
  }, [_c('span', {
    staticClass: "Hyperlink CharOverride-4"
  }, [_vm._v("2.Throwing Waste in the Nature Can be Dangerous\t   ")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-5"
  }, [_c('span', {
    staticClass: "Hyperlink CharOverride-4"
  }, [_vm._v("3. The Accident\t\t\t\t\t\t ")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-5"
  }, [_c('span', {
    staticClass: "Hyperlink CharOverride-4"
  }, [_vm._v("4. Grandmother Snowberry’s Visit")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Hyperlink CharOverride-4"
  }, [_vm._v("5. Cousin Cress, Why He Was Called that Name, and How He Aired the Turtles")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Hyperlink CharOverride-4"
  }, [_vm._v("6. The Celebration Party and Minette-Mini-Mouse’s Whipped Cream Adventure")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-5"
  }, [_c('span', {
    staticClass: "Hyperlink CharOverride-4"
  }, [_vm._v("7. Evening in the Singing Troll’s Tree")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-5"
  }, [_c('span', {
    staticClass: "Hyperlink CharOverride-4"
  }, [_vm._v("8. Afterword")]), _c('span', {
    staticClass: "CharOverride-5"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "Preface ParaOverride-6",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The idea, to write this book, came from the time where the author herself had a small child who loved a “goodnight story”. The little family spend some vacation weeks every year in the South of France. There were no books to read from. Therefore, instead the imagination was used to, together with the child, create stories. This book is inspired by those stories, though they are not quite the same.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The book is about nature, friendship between animals, insects, and plants. It is also about the importance of keeping a good mood in general, but also when there are duties and tasks to be done. Furthermore, to enjoy them, and have fun at the same time. Hopefully, the book can be used to spread joy and interest for being together with nature as well as give the child some knowledge about it. Perhaps also, when the book is read, stimulate the child’s creativity to draw pictures about what it was told, and maybe create a continuity of the story by itself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("There are not much more wonderful than to hear a child laugh, and see the joy in its eyes, it just gives the best of the mutual quality time, when reading together, and talking about images and text, a common free space, and a bond are formed, between the person that reads and the child. Thereby, also memories are formed for both. A child who is used to be read for, will in the future also be more interested in reading itself. That is scientifically proven.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "About-txt"
  }, [_vm._v("About the text")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The marked text, in the book, are questions for the child to answer. Please, give the child plenty of time to reflect and answer, to sing and hum, since it is important to involve it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The rhymes/songs can be hummed as one pleases. Since that also gives room for the imagination and creativity.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("I would like to suggest, letting the child/children draw pictures of what it/they have heard in between the readings. The quality of their drawings is not important. It is only important that they are prised for its effort. The empty pages at the end of the book are suggested to be used by the child after the book is finished.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Then again after a few days, let the child “read” aloud the pictures in the book, for the reader, inclusive its own drawings.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Why not save the book? It might in the future be fun to show it to the child/children. Then it/they can see how it/they, as a small child, drew and perhaps wrote. It might evoke pleasant mutual memory.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "Chapter-1-Heading",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("1. The Singing-Trolls and Their World")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Once upon a time there were a cluster of olive trees in a park called the “China Park” far away in a country called France.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("On the front side, you can see the three trolls that this book is about:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry, Carrot and Tomato. That were their names, odd you might think, but there was a good reason for their names.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("On the picture you can see that they had big soft ears that they heard so very well with. They also had good sniffing noses. With the help of those two senses, they both heard very well and could smell, on long distance, all the smells and noises in the wood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The trolls’ coloured hair was as stiff as scrubbing brushes or like hedgehogs. That was extremely good, since no dangerous big birds or anything else could come and snatch them. If they tried, they would stab themselves on the troll’s hair. Another good thing about their stiff hair was, that in case they fell down a tree or something, they did not hurt their head, since their hair was as strong as bicycle helmets. Only one thing was a little troublesome about the hair, and it could be quite troublesome. It was to put on their soft woollen nightcaps that they sometimes wore on cold nights.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The trolls were very agile, almost like small monkeys. They were good at climbing trees and jump between the branches. Also, they were very skilled with their hands to create and work with many things. Other than that, they were fun, creative, and very active.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The three young trolls that you can see on the front page were brothers and lived in the same tree in their respective caves. There were many other trolls in the family, but they lived in other trees, a bit further away in the olive tree-wood. The young trolls did not meet their family members very often except for sometimes. The one that they met most often was Cousin Cress, who often came to the troll brothers’ tree to play. He was now so old that he soon would be moving to their tree anyway.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-10"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image004.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("On this picture, you see the three trolls carrying berries, vegetables, and a fruit (tomato), that was from these things, their names were inspired by.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Those were the names of the three trolls, that lived in the same tree, and that this book is about: Tomato, Blueberry and Carrot here above you can see your new friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Can you guess now, who is who of the trolls by looking at their hair?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Where is Blueberry, and why was it that he had that name?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Can you see who is Tomato?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("And who is then Carrot?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-13"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image006.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("All the trolls, in the big troll’s family who lived in the olive tree wood, called themselves for the Singing Trolls. That was because their language was like singing. They were social, always happy and went along humming and singing all day, therefor they were also called the singing trolls by everybody else in the wood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("So, orange as Carrot, blue as Blueberry, red as Tomato. Cousin Cress, he had very, very green hair. He still lived at home in the family tree together with his parents, and the other cousin. Some of the other cousins also came to visit and play at times. Also, all the other family members had different, bright colours on their hair and names that fitted to the colours. That was of practical reasons since it then was easier to remember their names. Their hair was also thick, and strong so they did not need to wear caps or hats in winter, unless they liked to.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("All the trolls were a bit shy and liked to hide among the greenery in the wood. The one of the trolls that was most shy was Tomato. He always arrowed away to hide if he heard anybody get near, or guests came to the tree, and then he hid in his cave at first, until his brothers called him to say, that it was safe to come forward. The others hid sometimes if they heard unusual or dangerous sounds. But that was seldom. It was a good and peaceful wood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Tell me if you are shy as Tomato is?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(Very many children are, but usually they grow out of it)")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("All the trolls were all able to turn their long ears after the sounds. That could sometimes look a little funny since each ear, turned different ways, when they jumped. The ears were all pink inside and could be turned in different directions at the same time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Do you have a good hearing?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Can your ears turn in different directions at the same time?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Do you have long ears like a troll?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Inside their homes, in the little caves, they had it all so cosy and comfortable. As they were very social, they liked to invite each other, their friends and of course each other’s pets to their home to eat or play.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("You see, it was normal for the trolls to have a pet and in this case, it was mini turtles. Everybody in the big troll family had a mini turtle as their pet. The turtles came mostly along when the trolls went out playing or visited their other friends, e.g. the mice, hedgehog, the butterflies, the humble bees, the blackbirds, or others.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The trolls in the olive tree wood had no tails, as many other trolls might have. That was very good because, they liked to slide down the trees summer and winter. So, it would not have been good. They simply would have got a tail squeezed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Don’t you think so?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("What they had in their caves?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Inside their homes in the caves, they had everything they needed. They bathed and washed their hair in their mussel bathtub and had smaller mussel peel sink for their hands. It was very important to keep both their bodies and their combed hair clean and shiny. Especially, it was most important that the hair was clean so it really could lighten up and could be seen from a long distance. It was because they could then immediately, on the colour, recognise who came in between the trees. Of course, it is always important to have clean hands before eating, when one is having guest, or before one goes to bed at night. It is natural because that keeps one healthy, the trolls said.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Are you also washing your hands often to keep healthy?")])]), _vm._v(" "), _c('p', {
    staticClass: "Left-side-image ParaOverride-15"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image007.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Right-side-image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image009.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-16"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The troll’s bathtub and sink above. Here you can see the troll’s moss-beds. They were soft and smelled from wood and grass.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("When it was cool at night, they used to draw a soft leave up to their ears, to keep warm. Some night it could get a bit cool. Therefore, the trolls sometimes wore nightcaps and woollen socks to keep warm. It was both practical and cosy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("As said, the tree troll had each a mini turtle as pet. Underneath Blueberry’s bed lived Sugar. In between, during the night, he put down his hand and padded her lovingly. That made her happy since they were the best of friends. It was so cosy to have a pet since, when the trolls came home, there was always a little turtle who was singing, and played some music. At Tomato’s place lived Arnold and together with Carrot lived Calle. The turtles were really very small. They were both fun and musical. They played different instruments. Sugar, who lived with Blueberry, played the flute,  Arnold played a harmonica, and Calle had a banjo. Those three were together as a small orchestra. Since, the troll themselves loved to sing, and mostly all the time, the combination with the turtles playing different instruments was quite perfect. That was also the reason that everyone in the big troll’s family had a mini turtle. There was constantly music and song in all the trolls’ trees in the Olivewood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("However, we must mention that there was something troublesome about the mini turtles. They walked VERY slowly. Therefore, the trolls often took them in a little wooden tow truck, when they went on visit, or when they went out to play, but never mind about that. Then the troll brothers also had music on their way, since the turtles played it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("o you have a pet at home?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("What is its name if you have one?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Cousin Cress did not have a turtle as pet. He had a red parrot named John. That was lovely since John could whistle to all the others music. Why Cress had a parrot you will hear about a little later in the story!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The turtle Sugar, Blueberry’s little friend, loved coconut milk. She had a “sweet tooth”.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-17"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-6",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image011.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Here above you can see the turtles having a good time. They are almost as green as the moss. That was a perfect disguise. In front you can see Sugar with her beloved coconut milk.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Well, you know, coconuts are very healthy for both humans and trolls. You can get hold of the milk inside by drilling a hole in them. The trolls were very handy, they could easily do that.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Many human families like to get coconuts, to decorate their X-mas tables.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Have you tasted a coconut?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Do you perhaps also have a “sweet tooth”?")])]), _vm._v(" "), _c('p', {
    staticClass: "mid-image-on-next-page- ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-7",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image013.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Homework and cleaning plays on this picture is shown what more the trolls had for household work in their caves.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Kan, you name these things?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The trolls thought that if you want to boil a good vegetables soup, you need a pot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("-And if you want to wash your cloth or the floor, you need a bucket.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("-And if you want to iron you might need an iron, after having washed and dried your clothes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("The flooded floor and a visit by new duck friends")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("All homework, one must do having a home, were for the troll’s merle and always a play. They did not know what work was, since for them everything was a kind of play and enjoyable. To do it, they accompanied every task with a song, dance or making a fitting rime. That was the reason they were called the singing trolls. When they washed the floor, they simply put a dry floor cloth on one foot, and a scrub brush on  the other, and skated around singing. In between they dipped the foot with the scrub brush up in the bucket containing the soap water. So, this way, one foot scrubbed and the other dried while cleaning the floor. It was fun as well as efficient. That usually went quite well, but one day Blueberry stumbled and fell backwards and landed in the bucket with soap water on his behind. He and the bucket overturned, and all the water ran out on the floor. It got all flooded and Blueberry soaked. At the same time came a duck couple flying by the window. When they saw the little lake inside the cave, they turned around and decided to have a swim in it. They flew through the open window and landed in the nice little flat pool where they started to paddle around. They looked content and happy faced at Blueberry, who sat in middle of the pond and looked surprised at his duck guest. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Hello, hello’, said the ducks. ‘Nice place you have here, and so interesting you have decorated it with a pool.’ Blueberry sighed as he greeted them back, saying, ‘Well! Perhaps, it was not all intended.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then the ducks asked, ‘Are there any free flats like this to rent nowadays in your tree? It would fit us very well.’ Blueberry shook his head and said, ‘Oh no! unfortunately not.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("A minute later, the two other brothers, Tomato and Carrot came around to ask if he had finished his floor cleaning since they were done. They got big eyes when they saw the flooded room and the swimming ducks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Tomato asked cautiously, ‘OH, perhaps you need a little help, or are you having guests?’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Well!’ Blueberry answered hesitantly. ‘yes, it seems that I might need a little help to get the water out of the cave, but first we should thank the ducks for their kind visit. He turned to the swimming ducks and said, ‘Thank you very much for your visit in my home, but maybe you could you come back some other day? Then I will invite you on a piece of bread or something. You see, today I am a little busy. The ducks said, ‘OK, of course. Thank you for the swim you have a real nice place here. Then they flew again, out of the window. ‘Quack, quack,’ they said and waved at the troll brother with their wings. ‘See you soon, bye, bye!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Nice ducks,’ said Carrot, ‘I did not know you knew them.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘I didn’t,’ answered Blueberry a little bit tired. ‘Now brothers, do you have any idea about how I get all this water soaked up.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Oh, I know,’ said Tomato. ‘We go and get each our brooms. Then we can sweep the water out of the front door.’ ‘Yes,’ said the other two, good idea! ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("After that, within ten minutes, they had swept all the water out of the doorway. The soap water rand down the olive tree and spread a lively clean scent around it. Then Blueberry looked around in his flat and said, ‘Wow, I think that I never ever seen my flat so shiny and it smells wonderful in here. Thank you for your good help, brothers. This is a good day. I even got new duck friends and my trousers have also been washed at the same time. It has been a fun and efficient pre-noon.’ Then, he burst out in laughter and so did his brothers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then they looked out the window. It was a beautiful sunshine day in the wood and all their three caves were by now Saturday top cleaned. Saturday was their cleaning day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Now, it was leisure playtime. ‘Yeh! let’s get out to play something else. You can dry your pants in the sunshine Blueberry, said Tomato. Fine with me!’ said Blueberry with a happy smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("As they five minutes later reached to the lake bank near the human children’s playground, they saw their new duck friends swimming in it. They waved at them, and the ducks waved back quacking. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Did you understand what they said Blueberry? asked Carrot. Oh Yes, they invited us to come swimming in their home. So, he answered the ducks smiling, ‘Thank you some other time!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Sometimes the trolls hummed or trolled this song:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("verything i must do")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("UHU, UHU")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Just be happy too")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("I’m glad")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("That I can")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Since I´m a strong, handy man")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Bam, bam, bam")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("It’s all like a game")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("It’s fun all the same")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Tra la la, tra la la")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("So, it went on. Every time they did practical tasks, it seemed to end up in a fun play and in some new experiences.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Likewise, when they washed their cloth, they bathed themselves in the bathtub. They played with the soap bubbles, and made hats of the foam, or  played restaurant if they were cooking, and so it went on and on… They sang and hummed to everything, and the turtle’s made music that fitted the plays. They used to say, ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("tasks and joy can easily be combined,")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" and then they giggled.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Do you and your family also wash the floor the same way as the trolls?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Would you like that?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Do you play with the foam in the bathtub?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Gathering trolls’ superfood in the wood")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("When the trolls collected berries, nuts, and fruit for the meals or to store in their food cave, they co-worked well. One was up in the bush or tree; one was down on the ground, and one was placed at the food cave or by the tow truck. It was just like playing handbill. When the berry or the nuts were thrown from one to the other, they counted, ‘one- too, three and goal!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then they cheered and laughed as if it had been a real handball match.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("There could occur small accidents occasionally when they picked berries, or nuts and one happened when they were gathering blackcurrant berries. They took it mostly in a good mood. This other day, a minor accident happened when they were diligently working food collecting.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("A “nutcase” on mice Otto’s head!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("One day, the troll brothers were busy gathering hazelnuts on the ground underneath a hazelnut bush. They used to store nuts for the winter in their food cellar. This day they did as usual, one was picking up another was halfway to the truck and the third lifted the nut into the wooden truck")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("So, they counted, one-two-three, as they threw the nuts between them, but Carrot standing in the middle suddenly felt how a mosquito stitched his knee. He bended down to wave it away, as Blueberry at the very same moment threw a nut. The nut flew over Carrots head and landed in a nearby small bush. That would normally not be a problem, but this time a high scream and some “OF, OF” sounds came loudly from the bush.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The three troll brothers rushed to the bush to examine what and from whom that sound came from.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Underneath the small bush, they found their good friend Mice Otto holding his hands to his head and the hazelnut laying besides him, moaning.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("He sat there on the ground moaning. OF, OF, holding both hands to his head, a big bulge could be seen on his head, and the hazelnut lay beside. ‘Why did you throw that nut on my head? moaned Otto. I was only collecting nuts for my winter storage and did not do anything wrong!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Gosh! Sorry, sorry for that, Otto, said Carrot. I just missed to catch the nut. It was due to a mosquito sting on my knee. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Otto said, ‘OK, I see it was only an accident! Well thing happens! Oh, my head, OF, OF!")])]), _vm._v(" "), _c('p', {
    staticClass: "mid-image-on-next-page- ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-8",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image015.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The three troll brothers looked unhappy at each other and decided to bring Otto to his home to his big Mushrooms house, using the truck. They emptied the truck from nuts, put soft moss in it and lifted Otto up into it. Then they rolled him home carefully. On the way Tomato stopped at their own Olive tree and called up for Doctor Owl, who lived higher up in their own tree. ‘Dr Owl, please come and examine Otto. We accidently knocked him down with a hazelnut, when both we and he were gathered nuts for the winter, at the same time. We did not know that he was there.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘OK,’ said Doctor Owl, ‘I will be at the Mushroom house in a minute.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Back at the entrance to the mice’s home, Otto was placed in the shadow. Otto’s wife, Little Mum came worried rushing out with a bowl of ice-cold water. She placed a cold cloth on the bulge on the top of Otto’s head. The bulge was big like a little reed mountain that protruded through his fur.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Otto moaned but said thankfully, ‘Thank you, Little Mum, that was nice. It feels better already.’ The three troll brothers stood there feeling very guilty. Then the doctor landed and examined the patient. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Well,’ he said afterwards. ‘Otto has got a minor concussion and he must rest a few days in the shadow. If he gets worse, I need to be called on again. But I do not think so.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Otto moaned again and said, ‘Sorry, Little Mum, I really tried to gather a lot of nuts for our winter storage. The children eat by now so much since they are growing bigger.’ Little Mum clapped her hands together and said, ‘That is not a problem Otto. We have plenty of time.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then the troll brothers said with one mouth, ‘Otto, please do not worry, we will gather many, many nuts, and berries and come to your storage with them. You know that we anyway share all food.’ Now, they smiled again and felt better, since they could do something to help. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The doctor said, ‘So, so, so, this was only a small accident. Where activity goes on, small accidents might also occasionally happen. That is life, No one can help that. He sat a bandage around Otto’s head and after that he flew back to his clinic.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Little Mum now said, ‘What about a glass of fruit juice before you three trolls go back to work and Otto gets a little rest.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Tomato, Carrot and Blueberry smiled and sat down beside their friend, and had a little chat and a drink before they went back to their work at the hazel bush.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("They continued to collect nuts all afternoon both for their own food cellar as well as the one in the Mushroom House. When they had finished their work, they took each other under the arms and as always, swung their legs, like in a dance performance until they became completely dizzy. Then they threw themselves laughing in the grass. By now, they had become a little bit tired and sweaty.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("All their practical homework was for them only another fun game. But as you can see, sometimes unexpected things could happen along the way.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("A few days after this Otto’s concussion, he was again on his feet and all well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("And now you shout: One-Two-Three- Goal!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("And now, please tell me if you are helping at home?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Do you clean up your toys?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Gathering troll’s super food in the wood!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("All the trolls in the family had the opinion that if one did not get enough good food, containing lots of vitamins, one would get very tired and maybe even sick.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("So, they ate a lot of fruit, vegetables, and nuts. They really ate a lot despite their small sizes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("It is very nice to eat many vitamins if one does not want to catch  flu or some disease. The trolls wanted to become and stay super strong. In the world of the trolls, there was nothing called sweets; they ate instead sweet berries and fruit for dessert. Sometimes at parties they ate cakes made from nature-products. Sometimes their friends, the bumblebees came and gave them a small pot of honey.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("They said, ‘Eat healthy and well, then you will not “swell”’ and then they giggled.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Due to their smallness, they had to help each other to roll home one single fruit, and thereafter to cut it in pieces, and share it. That didn’t matter since they enjoyed the work. They were joking during it, since for them it was just another fun play. Of course, they shared their food since they were such friends, but they also shared food with their other friends in the wood as well. If you are friends, you will of course share everything!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Are you also sharing sweets with your friends?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("After the trolls had eaten any meals, they used to sing the")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("“Food song”, it had only one rhyme, and that was the same with most of their other songs and rhymes. One rhyme means that was easier to remember. Here comes,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("“The Food Song”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("I want lots of food,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("sweet and good.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("It’s called superfood,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Nuts and fruit")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("It makes me super strong,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Never ever mad or sad, Trala la, tralala")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("And after that, they said,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Eat as us. You will become handsome")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("and super strong")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Can you now hum the “food song”?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(The song can be hummed as you like)")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("This was their food song that they used to sing after or before the meals. They sang it, and clapped their hands, and sometimes they made a little dance. Tomato might then beat a bucket, Carrot stood on hands and Blueberry showed his strong overarm. Just like a gymnastic show!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Thereafter, they clapped themselves satisfied on their light-green bellies and lay for a minute resting in the green grass. It was good to remind oneself, about the importance of being grateful for the good food, and to always enjoy it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The troll’s superfood that made them so strong")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Can you name some of the fruit and berries on this picture?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Are you also eating troll’s superfood too?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("By the way, are you picky?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The trolls really needed a lot of energy since they were SO active every day, and diligent as well. They played, worked, and sang all the time.")])]), _vm._v(" "), _c('p', {
    staticClass: "mid-image-on-next-page- ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-9",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image017.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Therefore, they needed food with many vitamins and of course good taste.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Not to forget that they REALLY didn’t like to go hungry or get the feeling of a rumbling stomach.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-17"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image019.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Her above you can see how they one day made picnic on a tree stump in the wood. Here they had used a mushroom growing on it, as plates and they set the table nicely.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Set the table nicely before you eat and it will taste good and sweet.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("That was another fun and important play they enjoyed. They always used their fantasy to create a new pretty way to set the table before they were eating. On this picture, they had set the table this way. It was to celebrate Blueberry’s birthday and therefor they placed a blue flower on his table, since he liked the blue flowers all the best. He meant that blue fitted his hair colouring most well. They usually used walnut shells to drink or to eat soup from. They said, ‘If you set the table pretty before you eat the food, it tastes much, much better. It is as if you added an extra good spice to it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then they sat down to eat, and the turtles started to play some music. After a little while trolls strangely enough felt very sad, and tears started to run down their cheeks. Then Tomato got what was wrong. He turned to the orchestra and asked, ‘Why are you playing funeral music? It feels so depressing.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The three turtles stopped and looked surprised at their nodes and said with one mouth, ‘Oh sorry, sorry. You are right!’ We accidently have chosen the wrong node plate in our nodes book. Wait a minute, we will just change the page!’ They looked a little embarrassed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("A minute after they instead played a happy birthday melody, and Tomato and Carrot sang, Happy Birthday to you dear Blueberry, Happy birthday to you! They laughed and thought that was mighty fun that the turtles had played funeral music at a birthday party. OH my, the trolls giggled and so did the turtles.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("It was always fun to compete about who could make the prettiest table of the week. As usual you could hear, ‘I will set the prettiest table this week.’ ‘No, no!’ someone else said, ‘that I will do!’ and at last, the last brothers would say, ‘no, no that will be me!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("When Blueberry saw his favourite flower on his birthday table, he said admiring, “Blue looks so pretty good on hair and body and everything, so therefore I decide that this is the best and most pretty table setting of this week!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then he smiled and made a little bucket of pure joy, because they had noticed his birthday, and had sung a birthday song for him, even if it by mistake had started with funeral music.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then the other two brothers agreed. Especially, Carrot was pleased, since he was the one, who had got the idea of decorating the birthday table and was awarded the winner of the week’s best table decoration. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Congratulation, Carrot,’ the two other brothers shouted.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("As before said, the trolls were very musical. It was due to the fact that their language was like singing. They were singing and humming when they talked. Their language was simply with melody. When they laughed and jumped, you could see their small light-green bellies jump up and down, and so did their big soft ears. It looked so fun that everybody that saw it couldn’t let be to smile as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The trolls smelled from olives, sun, and summer. If you scouted for them, you might be able to see their ‘traffic-light-alike” hair glimpse here and there among the greenery in the wood, and if you listened quietly, you might be able to also hear their giggling as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-17"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-11",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image021.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Here Tomato had arranged for a visit in his cave. The trolls used mussel-shells as plates and sat on chestnuts. Tomato was now out in the wood, looking for decoration for the table and berries to serve to his guests.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Now listen; there was one very serious rule in the world of the troll’s. It was that everybody always ought to be happy and content every day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("That was, if you were not, at least you should try your very best to be so. To remind themselves about this very important rule, they had a song that they sang almost every day. That was their “Happy song”.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("They hummed, sang, or rhymed it together in their singing language. Everybody now, sing along!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("“The Happy Song”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Little troll")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Do not growl")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Just be happy,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("for all you have")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Life is very good")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Depression,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("or being sad,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("that is very bad")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("It gives stomach pain")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("So, don’t complain")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("And then they whispered seriously, And acidity is contagious, and it pigs in nature, and in the air, and risk everybody to get sick.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Can you hum The Happy Song?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Do you also find that being in a good mood is important?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The trolls really meant that everybody ought to be happy, when they had everything, they needed")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Now tell me, do you have everything you need?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("What do you have that you appreciate the most?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("What do you think about someone going around being sour?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("They enjoyed also being good friends, being nice towards each other, AND never ever bully anybody. Good friends never bully each other. The trolls said with one mouth. It was VERY bad in their wood to do so or being evil to anybody. Especially, it would be extra bad to be a bad friend. That was not allowed to happen at all, among the troll family in the wood. That rule they had learned from early on, back home in the family tree, by Grandmother Snowberry.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The singing troll shared all they had, not only among themselves, but also with their friends in the wood. They played and sang all day and sometimes they sang or rimed a little rime about being “a bad friend”. It was to remind themselves, and others about how bad, and unpleasant that could be.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-18"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The one who is bad,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("makes everybody sad,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("He must be left on his own")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("All alone,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("UHA, UHA!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then they whispered seriously into each other’s soft, long ears,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("that’s only lads")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("That word “lads”, they would not say loud, since they thought it wasn’t a nice word.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("So, the song meant that the one who was mean to others got isolated and no one wish to be near him or her. Thereby that one could get very lonely.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("And who would want to be that?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Can you sing the song about being “a bad friend”?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("And now only whisper the “not good” word (lads)?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Something is right about how they thought here. Who would like to spoil a nice day going around being in a bad mood, growling or being a bad friend, and thereby infects the nature and the air.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("USH NO!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("They meant that these manners were as dangerous as virus or a bacterium that one can get sick from e.g. get influenza or stomach pain. That was what they had learned from childhood. Negativity was simply dangerous for all.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Therefore, by the trolls, it was strictly forbidden to growl, fight, swear or say bad words. They just wanted to stay happy, healthy and have fun.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Another different thing among trolls was that they did not know what it was to be bored, since they were out playing every day, all the year round in the fresh air in all sorts of weather.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("You see, television, iPhone and all sorts of IT did not exist in the trolls’ world. So, nothing like that could ever disturb their good outdoor play days in the wood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("They played with whatever they found: sticks and leaves to sail with or on, in the streams or puddles. They were skilled swimmers so it was not a big deal if they plumped into the water. Then they just got up, and shook off the water like a dog, all laughing or else they continued to make a splashing water fight.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("In winter, when it was snowing, they built snow caves, snowmen or used dead leaves as slates on the snow. So no, they were never bored.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The troll brothers’ friends were:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Aunt Iris, Pumpkin, the Crocus flower family, the mice, the hedgehogs, the bumblebees, the butterflies, the blackbirds and of course their other cousins from the family tree and their green haired cousin Cress: There were, as you can hear, many friends to play with and talk to.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Cousin Cress often came to play. He always brought his red parrot John. The parrot mostly sat whistling on Cress shoulder and contributed to the trolls singing and the turtles’ music making.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Cress had by now, become grown old enough to come visiting without being accompanied by a grown-up troll. Within short, he was planned to move to the troll brother’s tree. He looked forward to his move.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("His three cousins had already secretly started to prepare a nice cave for him. That no one else knew about.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("So, please, do not reveal that to anybody yet?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Do you have a best friend?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("What is the name of your best friend?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The Trollbrothers’ friends in the wood")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The mice family’s home")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-17"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-12",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image023.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("This is the mice-family home had their entrance in a big mushroom hat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Their house was called “The Mushroom House”. From their entrance they had a big cave down under in a soil heap. Under the mushroom’s hat, the young mice had their rooms. Their home was situated in the nearby of the singing troll’s tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("They were five in the family: dad-Otto mouse, Little Mum and three young mice. The oldest of the young mice was called Minette. She was very enterprising and sometimes that went somewhat just too far.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("On the picture, you can see her as she had climbed to the top of their home. She was humming up there, I am Minette-Mouse I love parties, dancing, and noise!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("She just loved partying, dresses, music and so on. She was a real “party princess”.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("On the picture above, you can see that in this family the grownup mice were white, and their children were grey. The smaller siblings were always a little bit envious at Minette since she was so enterprising, but that, the parents were mostly worried about.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("In the three, singing troll-brothers own tree, a bit higher up, lived other friends such as, Dr Owl and his wife and still higher up, in the crown of the tree, lived the blackbirds. They used to sing so wonderfully in summer-time, that it could be heard inside all the caves in the tree, and even around the tree into the wood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("In the nearby, on the other side of the tree, was a big butterfly bush, and there came always, a flock of butterflies to eat from the nectar of its flowers. They were so kind and sociable, and the trolls used to talk to them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The bumblebees could mostly be found flying around in the rosebushes or in the spring near the Crocus bed area. Both places were near to the children’s playground in the park and for the bees there were a lot of pollen to gather.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Other good friends were sweet Aunt Iris and Uncle Pumpkin. Aunt Iris face was like soft velvet martial. She was a good and caring friend, and lived a little bit down the path near to Uncle Pumpkin. She was also good at listening, since she was so clever. The three-troll brothers sometimes came to consult her, and ask for some advice, or seek a bit of comfort if something troubled them or if they felt a bit sad.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Who are you asking for advice?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("And who is comforting you in case you are sad?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-17"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-13",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image025.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("On the picture, you can see Uncle Pumpkin laughing and saying “Hello”. This day, it was Tomato and Carrot, who came to talk to their friends. Pumpkin always laughed about everything, and therefor the trolls loved him a bit extra. He had a deep, brimming voice and he was very good at telling fun stories. He used to “zumm-brumm” along when they were singing. He was their special cosy. Sometimes the three brothers sat down in front of him and said, ‘Uncle Pumpkin, please tell us a fun story?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("He always did, and afterwards the trolls were rolling around laughing in the grass.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Please say, with a deep brimming voice, just as Pumpkin,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("” Hello, hello little one”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("The blackbirds")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-17"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-14",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image027.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("On this picture you can see Mr Blackbird eating of his favourite dish: apples. He is also the postman in the olive tree forest. He carries the letters in the postbag holding it in his beak. Sometimes, he also has a lunchbox with apple cuts and cherries in his bag. It was usually his wife who had prepared it for him. He always otherwise would have said, ‘Don’t mind that I can pick something on my way.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("She did not agree with that. ‘Better be prepared, then the work goes easier if one eats well,’ she always said.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("The Crocus-flower family")])]), _vm._v(" "), _c('p', {
    staticClass: "mid-image-on-next-page- ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-15",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image028.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The trolls liked very much to play with the Crocus-flower family. It was always in a good mood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The sweet Crocus flowers they were lightening, like lilac little lamps in springtime, down on the ground. The trolls like to run around them chasing each other and on the way tickle the flowers under their heeds so that they opened them when they laughed. You can see, how some of the flowers just have been tickled so that their crown leaves are all brittle. Then they laughed and said, ‘Oh no stop, stop it is so tickling, ho, ho.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Here, you can see how Blueberry and Tomato tickling the flowers. You can see the flowers smiling faces. Be careful when you are out in the nature, so you never tread on flowers. It will hurt them, and they might get a headache, sometimes even worse than that.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The troll brothers sometimes called out to the bumblebees when they were playing with the crocus family. ‘Hi, Bees, now you can come and take pollen here, or here, we have tickled this one and that one.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The Crocus flowers liked that a lot too, since they also love the bumblebees. It was an entertaining mutual fun game. These bees are friendly, but they mostly liked to collect pollen from the rose hedge in the nearby from the olive trees, not far away from where the troll brothers lived. A Bumblebees looks a little like a “teddy bear bee”.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("The Teddy bear-Bumblebees")])]), _vm._v(" "), _c('p', {
    staticClass: "mid-image-on-next-page- ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-16",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image030.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("On this picture, one of the troll brothers’ friends, the bumblebees are on its way around the rosebush. It is all velvet dark brown with an orange stripe across its back and is white on its butt. It has four silvery wings. It is swinging them so fast when it flies, that it is difficult to see that bumblebees have four wings")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Please be aware, that these bees are a little bigger and thicker, than ordinary bees. Ordinary bees are tiger stripe, yellow and light brown. Especially, be careful with those bees called wasps. They are even bigger than the two other sorts of bees. They have a long tip rear. On that sits their spear that the use to sting with. They can be a bit aggressive. Never get close to them, or tease them, since they can get afraid, or angry, and then sting. Even if they do not mean to.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("But bumblebees don’t ever sting. They are so very kind and playful.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Hello,’ called the trolls, Mr Bumblebee, come to me, and give me a flight on your back, please?’ So, sometimes they did and how they together flew! The trolls became all dizzy. Sometimes, they fell of and landed laughing in the soft grass. The bumblebees summed smiling as they flew on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("What luck that the small trolls had their strong, “bicycle helmet” alike hair to protect their heads. Otherwise, they might have got headaches, or injuries.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Tell me, do you know what bees can produce?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(Yes, they can produce honey)")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("To be honest, the singing trolls were special fond of their butterfly friends, since they were so caring and loving. They came along flying single, or sometimes in a flock, and surrounded the trolls with their soft cuddling wings, and lovingly whispering voices. They whispered softly to the trolls, ‘Please, follow us to the butterfly bush. We can talk and play there while we are gathering pollen. There is wonderful to be, and good climbing branches for you, and the smell of the flowers is so good!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then they swirled along and continued with their low voices saying, ‘Remember always to smell the food before you are enjoying it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-19"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Oh yes, we always do,’ the trolls answered the butterflies, and continued, ‘One ought, as well always to be happy and thankful for the good food, ho, ho!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("The butterflies")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-17"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-17",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image032.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Above, you can see a butterfly gathering pollen in their favourite butterfly bush. They had different favourite bushes, one bush had light blue flower, one had white and another pink.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Look at the butterflies’ beautiful colours. One might believe that it has eyes on its wings, but it is only a pattern or drawing that looks like it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("What colour do you like the best?")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "mid-image-on-next-page- ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-18",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image034.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("The Hedgehog Family")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The hedgehog family was also some of troll brother’s friend. They lived in a garden waste pile, nearby. In it they had a warm and cosy cave. You bet that in that cave there was fun and plays since there were three lively small and wild cubs. The trolls loved to play with them and made leave-wars with the cubs, until they peeped screamed for joy and got quite wild. Gosh! They were sweet and fun. But sometimes the parents had to act to prevent accidents to happen. Sometimes the cubs begged, ‘Please, Mum, may we go visit in the troll brother’s tree?’ Mum Hedgehog always said, ‘No you need to grow a little bit older first. That is too far for you to walk.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Plays and nature toys for trolls")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The trolls played with everything they could find outside in the nature. They found sticks and drew or wrote on the ground, and then they invited the youngsters, from their friends to come and play school. Other times they used berries for foot or handball-matches, or they used moss and made different hats for a hat parade and decorated their small friend as well. After that they made a hat parade along the wood path. Imagine what a sight when everybody marched on in different hats in time. At the end of the line came the turtles and played some military march music.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Leaves and flowers were often used to make flags or sometimes fun sun hats. Sometimes, they found birds feathers. They fitted well to tickle each other or others with. That could make everybody scream from laughter. Sometimes, these things could also be used for umbrellas, in case of rain.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('p', {
    staticClass: "mid-image-on-next-page- ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-19",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image036.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Sometimes the trolls would build an Indian tippy between the trees. Tippyes are like the indians tents, but made out of branches. It is cosy to sit inside it. Sometimes, the trolls put a lot of moss and leaves in between the branches to keep it warm inside, and the wind out. Just the way that real indians would have done it. Sometimes in warm summers, they just made a tent out of their bedware, if it was not raining ofcourse, and instead they played “camping”. These were some of their favourite plays. As you can understand, they always found a lot to do or play with.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Have you ever made a tent out of your blanket, perhaps between two chairs?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Wouldn’t you like to play inside the trolls tipie?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Here below you can see how the trollbrothers had build a bridge over a small stream. Not too safe to walk on! Not to be recommended.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-13"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-20",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image038.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Do you think this bridge looks safe enough to walk over the stream on, with holes in it and all?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("What else was there to do, e.g. on a rainy day outside. Well, the little trolls were inventive, that you already know by now. They just loved to paddle barefoot in the puddles or to make good mud to build with like real bricklayer. They could also get very muddy and dirty from that, that did not worry them since the rain would clean them. Or else they liked to gather water, so they could offer extra drinks to flowers and bushes around. It was as well lovely, they thought, to now and then, dance a “Rain-dance” in the rain in their bathing pants, or even start a small splashing water ward. They were very inventive as you can see.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Sometimes, a little too inventive, since occasionally it could end badly. That you will soon hear about.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-20"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-21",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image040.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("There are MIGHTY much, toys out in nature. Some, you can see on this picture.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Can you guess what on the photo the trolls used as flag?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("What do you think they played balls with?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Can you see what they used as helicopter wings?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("What did they use to tickle each other with?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Don’t you think they might use little flowers sometimes as hats for hat parades?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("More good things about the toys that nature provide was of course, that the trolls didn’t have to clean it up, and put it in boxes or drawers as if playing inside. But something very important was to be remembered and that was:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Never ever throw waste in nature that is strictly forbidden.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Always be good to nature and do not brake or damage ANYTHING")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Said the trolls and looked very seriously. They, also themselves, had some bad experience about waste found in nature.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Other plays for singing trolls")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("They really liked to play in a big flowering Mimosa- tree, with its plenty of yellow flower. They jumped from branch to branch as they hid from each other and called out, ‘Can you see me now, or now?’ The tree smelled lovely as the best of all perfumes. The trolls became all yellow from the flower-pollen, both in their faces and all over their bodies. The tree also liked them to play in it, since joy is so contagious, and it therefor gladly shared its flower pollen and got in a good mood.  The trolls enjoyed themselves and laughed when they afterwards looked at each other looking like Chinese trolls. Then they said, ‘Now we look like people living in China, they are more yellow in their skin as us trolls. We are greener even if they are like us inside. We now also smell good as well,’ Blueberry said, ‘OH, I wish to keep this colour so I will nor wash myself anymore, at least not today.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Have you noticed how joy is spreading from person to person?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("What about if someone is negative and grumpy?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Tell me, what happens if you smile at someone?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("On the next picture you can see, how they jumped from branch to branch and called to each other: ‘Can you see me? no, can you see me?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Perhaps you, like they, agree that everybody is the same inside no matter what colour their skin has on the outside?")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('p', {
    staticClass: "mid-image-on-next-page- ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-22",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image042.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("After their play they didn’t want to go for a shower that evening, but the weather shifted. The same afternoon came a heavy rainstorm, so they were having a shower anyway. The heavy rain showered them clean and the sun and wind dried them up. Only the lovely scent from the Mimosa tree stayed on them. After that they found another fun game to do.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-14"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-23",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image044.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("An existing rain play was to play on waterslides, but also a somewhat risky one, as the low the water sliding on the tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("You see, when it rained, there were formed small streams on the tree trunks, and they were just perfect for water slides. That was MIGHTY fun! Here you can see how Tomato and Carrot comes whizzing down on their water-boards made out on dead leaves. They held small umbrellas in their hands to keep the balance.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Hi, Ho!’ They giggled and shouted, as it went. They whined and screamed for joy. This was one of their absolute favourite sports games, when it was raining, but as you later will hear about, it could sometimes end badly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("In summertime’s, it can be so hot and dry, that plants, flowers, and trees suffer from thirst and long for rain to drink but also, they all wish and long for, to be showered from dust. Therefore, we ought always to be happy for them when there comes a good summer rain shower.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The trolls also loved the rain, since that saved them a lot of time not to have to take showers and wash hair. They would much rather be outside and play even if it was raining.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Please tell, do you like to play on the slide?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Do you go out to play when it rains?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("To play “Hide and Seek”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Sometimes they played “Hide and Seek”, and during that play they changed of course roles now and then. One time, it was Blueberry who stood counting. Another time it was Carrot and at last it became Tomato’s turn.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-17"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-24",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image046.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Here you can see how Tomato had hidden his head behind a leaf and below, how Carrot had hidden most of himself in a hole in a tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Had they become invisible?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Can you see, what they forgot to hide?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-17"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-25",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image048.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Perhaps the two brothers believed that they were like the big birds called Ostriches. Those big birds always believe that if only their heads are covered in the sand, they become invisible. They do so if they get afraid of something. That of course is crazy since you always can see the rest of them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("At the same time, as Tomato and Carrot was hiding playing “Hide and Seek”, Blueberry was standing and counting to ten, but he cheated a bit, since he did not close his eyes as he was supposed to do. He giggled a little by himself and let believe that he did not see where his brother went. He wished to be smart and wanted to make a joke. Therefor he came, by chance, to pinch Carrot in his butt, and by chance, he stumbled on Tomato laying in the grass. ‘OFF,’ screamed first Carrot and then ‘OFF,’ screamed Tomato, and Blueberry giggled as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("After that they all laughed together. Carrot now suggested that it was better that he stood “on count”, since Blueberry obviously had troubles closing his eyes while he was counting. That was OK, the others said, but it did NOT seem to be any better that he stood “on count” since he was also cheating a little bit, peeking through his half-closed eyes to see where his brothers were hiding.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Do you sometimes play “Hide and seek”?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Can you count to ten?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Perhaps you use your fingers when you count?")])]), _vm._v(" "), _c('p', {
    staticClass: "mid-image-on-next-page- ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-26",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image050.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("To play “Hide and Seek” was a real fun game to play on a long afternoon. Still, it was also something you could get very hungry of. So, afterwards the brothers climbed up in a palm tree and picked a juicy palm fruit to share. They became all full and sleepy, so they decided to go home and sleep for dinner.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("“The train play”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("They sometimes thought it was fun to gather some of their friends, as well as Cousin Cress, and others of their cousins to participate in “The Train Play”. They used the wooden low truck to be one of the train wagons. In that, they placed the turtles, and they were most happy to sit in it and play on their instruments. That way they had music on the train. After the wagon came the mice, the hedgehogs, the birds, the bumblebees, and the butterflies. That way, the train could grow long. To accompany the train the turtles played, the parrot John whistled, and everybody sang along . The mice and hedgehogs whined, the birds sang, the bees and the other insects summed or brimmed. Just imagine this: Thala, la, PIV; PIV,  , , BRUM, ZUM, ZUM. It became the loveliest of music.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Fut, fut, fut! Sounds the train, here we come, tinge- dinging, here we come, everybody, sing along!")])]), _vm._v(" "), _c('p', {
    staticClass: "mid-image-on-next-page- ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-27",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image055.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Here you can see the three brothers Blueberry, Carrot and Tomato and, Cousin Cress, the turtles and parrot John. They were leading the train. After them came all their other friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Would that not be fun to attend?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("After being out playing long pre-noon days and thereafter having had a good meal, the trolls got sleepy. Therefore, they most often took a noon nap. They did it with joy and enjoyed it. ‘You get so lovely tired after a good play,’, they said yawning, but first they sang a little “Nap song” for the occasion.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("“The Nap Song”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("See you soon")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Let us take a little “sleep”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Do not weep")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("That will make us fit,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("for a later play,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Sleep well")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Sweet dream")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("I say!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then they made a high five and as usual. Who is first at home? That is me, no, that is me. Not at all since that is me. They shouted competing as they rushed home to rest and jumped up in each soft well smelling moss bed, with a content smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Often, they had said to each other, ‘Why not enjoy a good rest, if one can? That gives a lot more energy to the afternoon plays and everything gets more fun.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("If you had been standing underneath the troll brothers’ tree, a little later, you had been able to hear the snoring sounds coming from the caves: SNORE; SNORE!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("At the same time the turtles played a little rest melody before they also laid their small heads, on their moss pillows for a rest, underneath the troll’s beds? Everything became peaceful for about an hour in the troll brothers’ olive tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Can you whisper, “The Nap song”?")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer041"
    }
  }, [_c('p', {
    staticClass: "Chapter-1-Heading",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("2. Throwing Waste in the Nature Can be Dangerous")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Listen to what can happen if waste has been thrown and found by someone who really can`t tolerate to eat from it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Popcorn or fireworks corn?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("One day, Tomato had sacked a bit after his brother as they were on their way back to the tree to rest for dinner. When he came by the children’s playground, he found an interesting looking see-through bag.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-17"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-28",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image057.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("When he touched it crackled in a fun way. Inside it there was something exciting. It was some white foam rubber-like pieces.")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v(" Suppose it is some human children who has thrown it here")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(", Tomato thought by himself. He was able to read a bit, that Grandmother Snowberry had taught him and his brothers when they were smaller. On the bag was written “Popcorn”, with salt, the text said. Tomato did not know what that was but crept into to the bag to smell to the pieces. Oh, they smelled good from olive oil. He tasted it. They tasted well and a little bit of salt. He thought, ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Suppose it is not dangerous to taste a bite of a piece.")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" Before he had thought much more about it, he had eaten a whole “Popcorn”. It was about as big as himself. He felt super full. ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Good that I am only to go home and sleep for dinner, ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("he thought, and then he continued his way home. Already after a little while he felt how his stomach swelled up with air inside and tightened as a barrel. UHA, not good, he thought as he wattled forward with his big tummy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-14"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-29",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image059.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('p', {
    staticClass: "Indent-Txt"
  }, [_vm._v("Tomato’s tummy had swelled up like a balloon, and that wind was coming out from his behind.  It is obvious that he had stomach aches. Fart, Fart! it sounded from his behind. Not pleasant for poor Tomato. He is holding his hands on his aching stomach. He is passing Aunt Iris, who is giving him a useful advice. She is looking worried at his big tummy.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Aunt Iris said, ‘But, Tomato, what a big tummy you have, and you walk so slowly, are you unwell?’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Tomato had by now become really worried himself. He answered, ‘No not really, I have been eaten something called “Popcorn”. I feel like a balloon. And it aches and the sounds coming out.’ He rolled his eyes as he said it, as another little bang sound came out from his other end. Fart! it sounded.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘OH! I am so sorry,’ said Tomato all embarrassed, as he blushed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then aunt Iris said, ‘You better go home and lie down on your bed and then you need to do exercise, before you sleep for dinner. Then the air will come out of your stomach. Then you will feel better. Please, little friend, remember, from now on, never again eat waste lying around in nature.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Tomato listened seriously and frowned his forehead. He thought that the Popcorn perhaps was some sort of fireworks since, more and more fireworks’ sounds came out of him as he walked on. His stomach was still as a barrel. He was very glad that he did not meet anybody else on the way home, as it sounded behind him: FART, FART! The sounds were quit loud as well now, by every step he took. It was both unpleasant and embarrassing, he thought.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("At home he rushed to bed. His stomach pointed round and thick upwards and it also ached by now. Tomato moaned a little. ‘OF, OF!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("He moaned again when he now started to do the abdominal exercises that Aunt Iris had advised him to do. He lifted his legs up and down, and then came the sounds again, FART, FART, as small cannon-shots every time he did his leg lifting. It seemed like the air did come out as Aunt Iris had said.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("His brothers listened surprised, lying in their own caves resting, thinking that it was some very odd sounds that came from Tomato’s cave. Such sounds did not usually come out of a troll. Something must be utterly wrong, they thought. Blueberry rushed to Tomatoes cave and asked, ‘What is wrong Tomato, are you unwell?’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Tomato answered his brother, ‘I have eaten something called “Popcorn-fireworks pieces, that I found on the human children playground,’ he said, as he moaned and the sound came again from his behind,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Oh, well, well, not so good. Do you want me to go and get doctor Owl for you, Tomato,’ asked Blueberry, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘No, his brother replied unhappy, ‘but if you would please, just ask him if he thinks that I will die, or if he believes that the advice about the abdominal exercise will help me that I got from Aunt Iris?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry rushed up the tree to the doctor’s praxis and told him the story. The doctor answered, ‘OH NO! Tomato will not die, but it was a real bad idea, to be so uncareful, as to eat waste from others. We cannot all, who lives in this world, tolerate the same things, and therefore it is strictly forbidden to throw waste in the nature, and for others to eat it. Tomato will manage, even if it is unpleasant for him just now. The advice he got from Aunt Iris was good. He needs to press out the air from his stomach, and he will soon be well again. He needs also to drink a lot of water due to all the salt on that Popcorn piece. Send him my best regard, and tell him to stay in bed until he feels better.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry rushed down to Tomato and told him what the doctor had said. Tomato then continued his exercises, as at the same time the unpleasant sounds came out of him from the other end, and the smell was not good either. After a little more time, he felt better, and the bang sounds stopped so he could rest for a while. He also drank some water as the doctor had recommended.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry went back to his cave after half an hour to check on him. Tomato’s little turtle Sugar had followed Blueberry home to rest since he did not like the environment under Tomato’s bed. It smelled bad down there, and she disliked the sounds and got afraid.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Later, when the troll brothers had rested, they went back into Tomato’s home followed by Sugar, the Turtle and asked him how he now felt. Little Sugar went up to him and licked his hand to say that she was sorry for him. He padded her on her head. He said, ‘Thank you, little Sugar’ and then he told them that he had not been able to close his eyes. He was completely black under the eyes. He looked a little shameful as he was sitting reed checked on his bed. I am much better, I did not like the stomach pain or the cannon sounds, I think it would be a good idea to pass by the human children’s playground, so we can check the text on that paper bag. Perhaps the text said, “Fireworks corn”, and not “Popcorn”. In that case, I better get an appointment doctor Owl, to check my eyesight, since I might need glasses,’ he said thoughtfully and continued, ‘Now at least I will never again eat waste, never!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("His brother and turtle both nodded and Tomato said, no, we trolls eat troll`s food does not waste food. That`s the best!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Do you like popcorn?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Perhaps you tolerate them better than a troll?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Is it OK to throw paper, plastic, and things like that in nature?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("That afternoon the tree trolls only played some quiet plays since Tomato was a little bit tired and so was his turtle.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("From that day on the trolls continue to play well together, or with their friends and enjoyed life too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Sometimes they together sang their song about being good friends”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("We are all good friend,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("No matter which end,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("we turn up")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("to the top")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("if we beat a bucket,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("or stand")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("on hands")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Always just be good and loyal friend")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("That was a song they liked very much. They ended it often with a little dance show and a good laughter or made a high five to each other.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Can you sing or hum the song about being good friends?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Sometimes the brother went to visit Aunt Iris. They liked to tease her in a friendly way. ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("“Why are you so blue in your head aunt Iris?”, ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("they said smiling. Aunt Iris answered, ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("why are you so blue on your hair little Blueberry")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("- Then everybody laughed and together they all said,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("“Blue is pretty on top as body and might suit someone really well”.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Especially Blueberry nodded and smiled as he had the same color on his hair and in secret, he was so proud of that.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer044"
    }
  }, [_c('p', {
    staticClass: "Chapter-1-Heading",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("3. The Accident")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("As you now have heard, the daily life in the olive tree wood was usually harmonic, joyful, and pleasant for all the inhabitants of the wood. Everybody was good friends and shared whatever they had and was nice to each other.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("But THEN something happened that broke the peace and harmony. As you also have heard sometimes the troll brothers plays went a bit too far and could end badly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Yes, so it did, on a lovely rainy afternoon when the three trolls were playing on their water boards leaves gliding down the tree. Then it happened not better than that Blueberry fell of his water board, fell off, and injured his leg badly. USH, USH and how he then started to cry and scream. ‘AV, AV, help!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Tomato rushed to him and saw that blood was running from one of his legs. Blueberry cried and cried. At last, he fainted. Tomato tried to comfort him and held his hand as he called to Carrot. ‘Carrot, please, run fast to Dr Owl for help. It is an emergency!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-14"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-30",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image061.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Can you see he is all in pain and crying?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Can you see the blood dripping from Blueberry’s knee?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Carrot rushed to Dr Owl, who was sitting inside his clinic. He had already heard the noise. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Carrot shouted, ‘Dr Owl, please come fast, Blueberry has had an accident. He has fallen of his leaf Slade and has injured his leg. It is bleeding, and he has such pains. I believe he has now fainted!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("UHA, UHA, please help him!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Dr Owl replied, in his usual calm manners, ‘OK, I will be there soon, please tell Tomato to bring the bandage box.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("At the foot of the tree lay Blueberry crying REAL loud. It was such a shame for him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Do you think as well, it was a shame for Blueberry?")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer049"
    }
  }, [_c('p', {
    staticClass: "mid-image-on-next-page- ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-31",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image063.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Dr Owl came flying down in a hurry. The bandage box stood ready, retrieved by Tomato. The doctor examined the leg, and said it was unfortunately broken. Then he laid a plaster around it, and told Blueberry and his brothers that the leg was now to be kept plastered and still for about six weeks; blueberry must keep still during all those weeks that was utterly important. After that the leg would be fine again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The following days, Tomato and Carrot re-build Blueberry’s wooden bed. They sat wheels on it. That way, he could be driven around during the resting and healing time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("That was quite smart of them, don’t you think so?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("When Aunt Iris heard about the accident, she nodded with her blue head and sighed. Then she said thoughtfully, ‘Yes! when the “Accident” is out about, someone must cry that is most sad.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("And uncle Pumpkin repeated several times, ‘UH! yes, yes indeed sad!’ On that day he did not even smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("When Mouse Otto had heard it all, he rushed home to his mushroom and shouted into the nest, ‘Little Mum, Aunt Iris said that the “Accident” is out and about, hurry and get the children to bed, so that no one else must cry.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Gosh! Otto, what are you saying,’ Little Mum answered, ‘yes, yes!’ and she saw to it, that the young mice quickly were put to bed to prevent further accidents. There the three mice youngsters lay, understanding nothing, in their beds at light daytime, and sour they were!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("“But we did nothing wrong! they shouted.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry’s sad mood and Aunt Iris suggestion.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Well, now for some weeks Blueberry was sitting in his bed with his plastered leg and was driven around by his brother. The pains had successively gone. Would you then believe that he was content?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The answer was NO, NO he was not, even if his brother sang the “Happy song” for him every day and did the best they could to cheer him up. No, he was not happy. He was instead very unhappy. Rather sour, one could say.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("They placed him in the shadow, so he would not get too hot, but even there he just sat and hung with his head")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Nothing of all that the brothers or all the friends did for Blueberry could lift his sad mood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Do you have pains in your leg, little brother? asked Tomato and Carrot. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘No, no, BUT…I’m so bored! I AM BORED! I want to be up and jump and play! I JUST CANNOT STAND IT!’ Blueberry shouted angrily. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Blueberry, Dr Owl said specifically that the leg must rest, to grow well and strong together,’ said his brothers with one voice, as they looked worried at each other and shook their heads.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("All the friends came to Blueberry bringing fruit, sweets berries and nuts to him. The blackbird was singing songs for him.  Pumpkin told him fun stories every single day, and the brothers drove him around, so that also he could be a part of everything that they were doing. Still, nothing, just nothing helped his sad mood, USH, USH!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("At last Carrot and Tomato saw no other way than go to sweet and clever Aunt Iris to ask for some advice. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘What are we to do, Aunt Iris, Blueberry is in such a bad mood that we start to be afraid that it will infect us all, and that we will get sick from head, hearts, and stomach aches, or much worse! It is really a shame for him, but even for us, since bad mood is a serious virus,’ the two brothers said quietly, and as a tear also rolled down Carrot’s cheek. They stood there with bowed heads in front of Aunt Iris.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Aunt Iris looked thoughtfully, feeling sorry for the small troll brothers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then she sighed and said, ‘Yes, when the “Accident” has been out and about, someone always will be crying, but when the pain has stopped, they also must stop it again and lift their mood. I think, it is now on time that you two go and get Grandmother Snowberry. She is so wise and a little bit firm. It is best to do that, so that not everybody in your tree gets ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("If not, then there will become quit and silent in our part of the wood, since no one will laugh, sing, or play music. Perhaps, the sickness will even spread.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Tomato and Carrot thanked Aunt Iris very much for her good advice and went home. The same afternoon they send a message to Grandmother Snowberry by the postman Mr Blackbird.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The postman Mr Blackbird helped by bringing the letter.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The postman hurried to deliver the message to grandmother Snowberry. In the letter the two troll-brothers asked their grandmother Snowberry to pay an urgent sick visit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("When Mr Blackbird came to the family tree, he delivered the letter and told Mrs Snowberry the whole story about Blueberry’s accident, and that he just couldn’t get out of his sad mood. Even if everybody around him did everything they could to make him happy. Now it was long after the pains in his leg had stopped. His brothers, and even all the friends, had started to worry, if they were at risk to get the “bad mood virus”, which can cause different diseases and even sleep disturbances and tiredness.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘UHA!’ the blackbird ended his telling, as he shook his head.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Grandmother Snowberry was very wise, and she was even the one that had taught all the young trolls in the olive tree-wood, the importance of always be keeping cheerful, if one wished to stay healthy. So had also the tree troll brothers been taught from early on, before they moved away on their own.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Even if Grandmother Snowberry was a bit strict. She had a big heart and loved her grandchildren dearly all life. That was real love.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("By the way, do you know where and how you can feel love in your body?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("So right, love can be felt where the hearts sit in the body. Love can also be felt as a wonderful warm feeling in one’s stomach and in the whole body. Love simply makes one feel happy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Well, Grandmother listened seriously to Mr Blackbird as he told her about the accident and Blueberry’s sadness. Then she looked at him over her rounded glasses and said, ‘Please send my warmest regards to my three grandchildren, Blueberry, Tomato and Carrot, and tell them that Grandmother will come and visit them since she so longs to see them.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The postman happily hurried back to the other end of the wood, and the troll brothers’ tree. There he told the good news. Grandmother Snowberry planned to come the soonest she could see them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Tomato and Carrot cheered and danced a small dance of pure joy, but Blueberry, he just sat there hanging his head as usual, saying nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("When Aunt Iris heard that Grandmother Snowberry planned to come, she smiled and said, ‘What good news, then everything will soon be well again’.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Pumpkin chuckled and said, ‘HO, HO, very, very good.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Mouse Otto rushed home to his home and said to the children, ‘Now you listen her children, when the troll brother’s grandmother Snowberry comes, it is utterly important that you three sit around, and listen what she is telling her grandchildren. She is such a good teacher, wise and loving. You might just learn something useful!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The young mice nodded seriously and said, ‘Yes Dad, we will!’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Little Mum-mouse, smiled by herself, and thought it was a good idea.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-32",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image065.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Doctor Owl’s home and praxis, higher up in the troll brother’s tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("He sat in his doorway, and had heard it all, since owls have a marvellous hearing. That was good news and in time, he thought silently.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Do you also have a sweet grandmother or a favourite grown person around you?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Who is that?")])]), _vm._v(" "), _c('p', {
    staticClass: "mid-image-on-next-page- ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-33",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image067.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Everybody in the singing trolls’ tree was waiting for Grandmother Snowberry’s visit. ‘AND LOOK! Here she comes!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-13"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-34",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image069.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer052"
    }
  }, [_c('p', {
    staticClass: "Chapter-1-Heading",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("4. Grandmother Snowberry’s Visit")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("When she came, Carrot and Tomato rushed happy to meet her.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Hello! Granny, oh! hello sweet, sweet Granny,’ they shouted, and both gave her a warm hug.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Oh! we are so happy to see you,’ they both shouted and jumped up and down like rubber balls.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("By the way, can you guess why she was called Snowberry?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("You see, it was because her hair was as white as the berries from the snowberry bushes. Those bushes have white flowers in summer and white berries in the autumn. They say “PUFF” if you press them between your fingers and they break. Just like a little bang pearl.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("By the way, please remember, that the juice from those berries is poisoning. Do not put your finger into your mouth before you have washed them in case you have been “puffing” the white berries. They are toxic for both humans as well as trolls. Grandmother Snowberry always brought sweet homemade cakes, for her grandchildren, in her basket")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Do you think Blueberry looked happy to see her?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Was that a nice welcoming?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Grandmother Snowberry’s medicine")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("As soon as she had arrived, Grandmother hurried to little brother Blueberry, who sour sat in his wood bed with wheels on. The owl sat a little bit higher up in the tree and listened. Blueberry sat sulking, ‘USH, USH, everything is dull.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The young mice had just gathered and given him some nuts. He did not even thank them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Now, the mice got “big eyes”, as they saw Grandmother Snowberry. They looked at each other and whispered, ‘Now we must listen well. That we have promised Dad.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Hello! my sweet troll child, here comes Granny with sweets cakes for you,’ she greeted him with a mild voice. Blueberry felt a little bit happy inside, but he did not show anything. ‘Now we are going to have a real cosy time together and talk about all the good things in life,’ she continued as she stood there smiling beside him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Are you able to see Grandmother, my child?’ she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Yes, yes!’  Blueberry answered, as he at last was looking up at her.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Now, it glimpsed a little bit of joy in his eyes. ‘You always have had so good eyes Blueberry,’ continued Grandmother.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Please tell me, before we continue child, do you also have good eyes?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Good my friend,’ continued Grandmother smiling.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Now show me your strong arms Blueberry,’ she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry showed her slowly his strong overarm and then suddenly he really tensed his muscles. ‘WOW,’ said grandmother loudly and admiring")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("And now you, who listens, show also now, your strong arm?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘OK, now please, show me your clever hands Blueberry,’ asked Grandmother then.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry stuck his small strong light-green hands foreword and showed them to his grandmother. He turned them up and down, up, and down. ‘OH, I can see they are very strong,’ she commented. Then she asked curiously, ‘Are they able to do many things? Please tell Grandmother what they can do?’ Now blueberry told his grandmother at firs very slowly, all the things his hands could do. The more he told her, the faster he spoke. He said, ‘They can play music, draw, and paint pictures. They can carve in wood with a knife, and they are strong when I climb in trees, and they are very good at constructing in wood or sand or building other things,’ he said proudly. Furthermore, he added, ‘They are so good catching balls or throwing berries as well as picking them in the trees…’  He went on and on and totally forgot his bad mood while he talked about his skilled hands.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("In the meanwhile, Grandmother Blueberry now sitting on his bedside, sat smiling and listened to his telling. Then she said admiring, ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("‘Oh, that was a lot, what skilled hands you have, my child. Those hands are much more skilled than Granny’s hands.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Now you, show your hands from both sides and tell what they can do?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Now, little  Blueberry, tell me what your brothers and friends all have been doing for you, to help you, and to make you happy during your sick time, where you have been forced to be inactive, and rest your leg?’ Granny asked with a mild voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry frowned his forehead and thought about the question. Then he replied, ‘Well, first they got the doctor for me. Then tthey re-built my bed to become a truck. Then they have been driving me around every day. They have been singing the “Happy song” for me, to cheer me up. They have also invited friends in for meals, but still been giving me the best pieces of all the food. The Blackbirds have been singing for me – And now Grandmother has come with sweet cakes. Grandmother just sat smiling in all her face with the rounded glasses on and listened.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Now it is your turn, please tell what others do to make you happy?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Tell also who is reading to you?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Do you enjoy it?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Wow!’ said Grandmother, ‘they have done a lot. Now, show Granny your fine mouth and your teeth,’ she said and pointed at Blueberry’s mouth, and continued, ‘tell me what it can do?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘The mouth can eat, sing and whistle,’ said the blue haired little troll.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Anything else?’ asked Grandmother with a big smile and twinkled with her eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("At first Blueberry pinched his mouth together, but he could not let be a big smile coming forward. ‘It can smile and sometimes laugh very much, and loud,’ he said. And then he laughed. ‘OH dada, dada!’ said Grandmother now also laughing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Now, you child, show a big smile as well?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Exactly, exactly,’ said Grandmother, as she now flashed to both of you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Look there! you are a very skilled little troll, can you perhaps also show me where does your heart sit, in your body?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry thought, then he said, as he put his right hand to his left side of his chest. ‘Here?’ he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘That is right,’ said Grandmother, ‘then tell me, what do you use your heart for more than living?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry pondered a bit, then he answered a little quietly, turning a pink in his cheeks. ‘To be happy and love with.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Exactly!’ said Granny and now they both smiled.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Who do you love with all your heart?’ she then asked mildly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("At first the little troll sat quiet, because with one he understood that he had forgotten to be sweet, and thankful to all those who had shown him so much love, and thoughtfulness during sick time. At first, he spoke with a quiet low voice, but he raised it slowly, and at last he shouted With a smile throughout his. In his “five o’clock” my brothers: Tomato and Carrot, Cousin Cress, Grandmother Snowberry, Grandmother Sunshine, Mum Candy Floss and Dad Licoricey. All my other cousins, and everybody else in the family tree. Moreover, I love all our friends in this tree, and all the others throughout the forest!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Now you little friend, can you show where your heart sits?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Please also tell who you love?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Wonderful!’ Said then Grandmother as a little tear glimpsed in her eyes. She was moved by his words. Then she suggested lovingly, ‘what about calling your brothers, to come to us. Then we might make them happy as well?’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Yes, yes!’ Blueberry shouted, as he almost jumped a bit in his bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Tomato and Carrot,’ he called loudly laughing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The brothers came fast and looked surprised at his smiling face. They had not seen him so smiling for many weeks. A stone of worries suddenly had lifted from their hearts. They began to sing “The Happy Song” and now, even Snowberry was singing, one could say shouted, as he clapped his hands.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt-2-indesnt"
  }, [_vm._v("Please sing or hum “The happy song”, you get so happy in “the lid” by singing.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Little troll")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Do not growl")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Just be happy,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("for all you have")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Life is very good")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Being mad or sad,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("that is very bad")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("it gives stomach pain")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("So, don’t complain")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("At the end they added, ‘And acidity is contagious, and it pigs in nature, and in the air and everywhere!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry’s mood changed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Now after Grandmother Snowberry had come, Blueberry began to sing and laugh, clapping his hands together with his brothers, since he now, was almost healthy. Still, for a little more time, he had to keep his leg kept still a few more weeks. He looked at the others playing and participated the way he was able to.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Doctor Owl had been sitting up in his clinic the day Grandmother Snowberry had her serious, but loving, talk with Blueberry, and since Owl have a super hearing, he had heard it all. He had then nodded and said quietly to himself, ‘That is most right, since the one who is sad, and moody cannot recover fast when they are sick. The one who keeps up a good mood, sings and laughs will recover much, much faster. That is something everybody ought to know.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Grandmother stayed for quite a while in her grandchildren’s tree. She sang for them and with them. She was cocking, baking, spread her kindness, and love around. Everybody enjoyed her being there inclusive, the turtles, and all the neighbours, in the tree as well as around it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then at last came the day where Doctor Owl came down the tree and took of the plaster from Blueberry’s leg.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Now, stand up, Blueberry,’ said Grandmother encouraging. Tomato, Carrot, and some of their friends, who had come for the occasion, clapped their hand as Blueberry stood up. He was all red in the cheeks from excitement, even if they used to be light green.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Doctor Owl laughed and said, ‘Congratulation! my little friend, the leg is fine, and you can walk on it. Take it easy, and do not be too wild at the start.’ Then he said, ‘OK, all is well, now, I better get on to my other patients.’ He sighed smiling and flew on to other tasks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("After that, Grandmother Snowberry suggested to her grandchildren to give a party, to celebrate this nice event: “Blueberry’s recovering”. The three troll-brothers clapped their hands and jumped up and down for joy. They thought it was a wonderful idea. Grandmother hastily turned to Blueberry and said firmly, ‘Stop there you, remember to take it easy, as the doctor said.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry said, ‘OK, sorry Granny!’  with a big smile on his face.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Otto, the mouse, who had been attending the doctor’s visit to Blueberry, afterwards rushed back home and shouted into the nest.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Little Mum Mouse, wash, and iron our best cloth. We are soon going to a party.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Yes, yes, Dad little, I will, but I believe that you might have gained a little too much weight, to fit into your party pants, you have not been doing enough exercise lately, but well a party will be fun.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Still, Otto did not care at all. He and the three children started to sing: He who has no pants, he must go with the end bare. HI, HI!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Little Mum Mouse sighed, ‘OH well,’ she said quietly, ‘that could get a little cold if it rains. Even if we mice still have fur on our ends.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Now, what do you say about to go with bare end in the rain?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Now came busy times to the three brother’s tree:  Invitation letters should be written and send out to everybody to the celebration party for Blueberry. Brother Tomato sat down at the big wooden kitchen table and wrote the letters to: Mum, dad, and Grandmother Sunshine. To all the  ants and the cousins inclusive of Cousin Cress in the family tree. After that he wrote to Aunt Iris, Pumpkin, the mice, the bumblebees, the butterflies, the small birds in the trees around and not least the blackbirds who of course also were to come. Thereafter, there would be a great deal of work to do for the Postman Blackbird, to deliver all those many letters.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The letter said:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Welcome to a party in our olive tree on Sunday afternoon!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("We wish to celebrate that Blueberry again can walk,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("and that life is wonderful here in our wood")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Much love from us, the singing-trolls")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Tomato, Carrot, Blueberry and Grandmother Snowberry.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Now, it became also busy days for the postman. He really didn’t mind because, now there were many visits to pay and many doors to whistle outside. It would be long days. He would start off at sunrise, and his wife had made him a lunchbox to put into his mailbag. He used to carry the bag in his strong beak. Whenever he arrived at a new door, he would sit down and whistled a tone. He so looked forward to bringing The invitation letter to each, who opened the door, and could also, at the same time, have a little chat with everyone.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Home, downstairs in the olive tree, there was a lot of activity going on, cleaning and baking. Still, everybody’s mood was high, Grandmother was baking, the three-troll brothers were swinging their dust clothes. They were washing floors with the soap water splashing from their small reed buckets, as they loudly sang, accompanied by the Turtle’s music playing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The party invitations brought joy everywhere in the wood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("In the family tree, the invitation was cheered. The one, who became the happiest, was of course the troll brothers’ mother Candy Floss. Now at last was her youngest son Blueberry well again. Well, she wept for joy. She has been so worried. ‘OH! at last,’ she shouted to their farther, Viggo Licorice. ‘Look here, Viggo!’ As she showed him the letter. After he had read it, he smiled and padded her kindly saying, ‘So, So! All is well again, that was good so now he can get around and move again.’ It is of course too sad not to be able to! Viggo also thought by himself. Good that Mum, his mother, Snowberry went over there, and got him in better mood.  He shook his head since he knew from himself that his mum was firm, strict, but very caring. He had tried her “medicine” himself when he was younger. It had always worked. Suddenly, he also remembered that she had drawn him a bit in his long ears occasionally. That was, as he remembered when he sometimes, had been too wild and naughty. He knew it was out of poor love and it was necessary that his mother had done so. Parents must be like that sometimes. It is because they love their children. Children must learn, Viggo thought. He also knew that his mother Snowberry was very good at fostering children and that she had a big warm heart. She did it all out of love. She had been the teacher for all the children in the family tree. He smiled by himself, while he was comforting his wife, but really, he knew that she was only crying for joy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Now!’ Viggo Licorice said to his wife, ‘we are going to look forward to the boy’s party. You better go and notice your mother Sunshine, surely, she has a lot of knitting to do. Then you find yourself a nice colourful dress, and a new apron to wear. We also must wash our hair shiny to the party. Especially your pink hair, so that the boys can see you come, at a long distance between all the greenery in the wood. We need to make them proud of their parents. Children wish to be proud of their parents as well as the other way round.’ Then Mum Candy Floss smiled again and took some few dance steps as she went on. She knew that Viggo Licoricey was right. She hurried to her mother with the message about the party and then she pondered about her dress. Then, she thought she might put a lilac orchid in her hair that day if she found any. She would of course find small presents to each of the boys and goodies for their pets.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Are you also proud of you parents?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Grandmother Sunshine got over the moon of excitement when her daughter Candy Floss told her about the party.  She was the one that provided all the big family with woollen socks, scarves, and nightcaps. So, now came an acute task for her, since it was a long time since the singing brothers had got anything knitted. Their woollen stuff must, by now, be much worn, she thought by herself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-13"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-35",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image071.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Here you can see Grandmother Sunshine busy knitting, sitting in her garden, in her favourite pink chair. Her hair shines like the sun’s beams. That is also why she was called that name “Sunshine”.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Dear me, she thought. ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Good that I have been busy knitting lately. Surely Tomato, Carrot and Blueberry need new socks and nightcaps. I will do my best to get it already for the party. I will pack them down in each small packet and bring it to the party visit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Grandmother Snowberry, who was now visiting her three almost grown-up grandsons: Tomato, Blueberry and Carrot away in their olive tree used to bake sweet cakes for all her grandchildren. Since, they were allowed cakes at special occasions such as celebrations. At first, she baked heart cockiest, and they were meant to look like the hearts of grandmothers beloved grandchildren: Tomato, Blueberry and Carrot and of course all the others as well. Grandmother Snowberry thought now about the youngest of the grandchildren. Since, she had got a new little granddaughter called Thyme. She was only four years and was the little sister of Cress. She would also come to the party. OH! how time passes fast, Grandmother thought. That would be Thyme’s first big party. Grandmother longed to see her again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("After that she had to begin to bake the BIG birthday cake with whipped cream and strawberries to celebrate that Blueberry had again become healthy and cold walk. She had worried about him, but she had not shared her worries with anybody. She felt relieved now and could enjoy this big, lovely job! Grandmother Blueberry liked to cook, bake, and taste it all, that you could also see on her round cosy body.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("A small currant berry accident and a meeting with an ant colonel.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The troll brothers, Tomato, Blueberry and Carrot were also very busy gathering sweet berries to offer to their guests and they had asked the mice to help gather nuts in the wood also, to put on the celebration table. Sometimes when they picked the berries small accidents could occur, that could delay it all a bit, like this.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry was up in a blackcurrant bush picking berries. Tomato stood on the ground to catch the berries that he threw down and Carrot stood at the wooden truck, so he could catch the berries as Tomato threw them to him. All worked well, until Blueberry up in the bush slipped a little and lost the berry that instead of falling in Tomato’s arms fell right in the middle of his face. SPLASH! It threw him to the ground. ‘OF, OF!’ he whined.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Both the brothers rushed to him. His face was covered with a whole black/lilac currant berry as he lay there.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry took his arm, and said, ‘OH, sorry brother, are you OK in there?’ Carrot removed the berry and a face all black was visible. A minute passed. Nothing was heard. Then two eyes opened in the black face and Tomato’s voice was heard. ‘WOW,’ he said. ‘The juice is so good! Taste it!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then he got up on his feet. He was all covered in the blackcurrant berry juice. Then he shook himself like a dog, and all the juice stood in a shower around him. He looked at his two brothers in front of him and started to laugh. They were all black dotted by the berry juice. ‘WOW!’ they said with one mouth, ‘We look like we have black measles.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Or!’ said the one all black faced, ‘like we are camouflaged dressed like warriors. Let’s play soldiers a little while. We can start with a soldier’s march song as we go down to the stream for a wash.’ Then they called their soldier’s orchestra, the turtles, to come and play the music as they marched on: ONE-TWO-THREE, we are soldiers on our way, on our way! They sang loudly, as the marched on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Up in their own tree, Grandmother Blueberries peaked out of the kitchen window and called out. ‘Stop there, you three black monsters, speed up to the stream for a shower. I need more blackcurrant berries for my baking!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The camouflaged soldiers stopped at once. They forgot their march and rushed down to the stream. There they took off their small leather shoes and sat them in a nice line on the bank of the stream. Six leather shoes side by side and besides the trolls’ three pairs of shoes the turtles placed their tiny ones all lined up. In another heap lay all their socks. Since the turtles had each four shoes it became a long line of shoes, and it became a high heap of socks as well.  In the water there was now a splashing water war going on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("At the same time, a colony of ants came walking by on their way home from work. They passed by all the shoes. They saw all these shoes in the finest and most soft leather lined up at the sand bank. The chief ant stopped and looked. He called to all the ant workers behind him. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Look there, this is apparently a thrifts store with a lot of fine beds for free,’ he shouted. We need to renew our beds at home in the hill. See, there are six doublet and 12 baby beds. No price on them, so they are for obviously for free. Everybody listens, half our workmen can you come forward and start carry the beds home, and the rest of you, go look for beware.’ All the ants came swarming and started to do as advised, to carry all the shoes in a long row away. The other ants swift found the heap of socks. One shouted to the leader. ‘We have found heap of sleeping bags, some are for grownups, and some are for baby ants!’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The leader answered, ‘Good, you can then roll them together, and start carrying them home as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Out in the water, the trolls suddenly saw how their shoes and socks started to trot away on their own. Carrot noticed it at first. He could not see the ants underneath the shoes, from where he was. He was only able to how the shoes move forward. He shouted to his brothers, ‘Hey, we need to stop our shoes. I think Grandmother called them home! Look! They are walking home by themselves. We better follow and stop them!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-13"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-36",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image073.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Here go all the shoes by themselves. That was anyway what the troll brothers saw and believed. But underneath were many small black insects, the ants, carrying them on their bodies. As ants are, very, very strong insects.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The trolls and the turtles rushed out of the water and saw that it was a colonel of ants that was carrying their shoes and socks away. They rushed after them shouting, ‘Hello there, stop, stop! Those are our shoes and sock!’ Thereby they succeeded to stop the surprised, and disappointed ants from collecting it all to become new bedroom inventories in their hill. The ant leader apologised very politely for their mistake. ‘Shoes! are they your shoes, and are the sleeping bags your socks? So sorry, we thought it was a thrift’s store, with ants’ beds, and sleeping bags for free!’ the ant chief said confused, and a bit annoyed, as he politely bowed to the troll and the turtles. They all laughed at the mistake, even the ant chief.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Thereafter, the ants disappointed continued their walk home. The ant leader pondered about why on earth the trolls and their friend wore beds on their feed. He shook his head as he looked down on his own many naked feet’s. An ant has many feet, you see.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("After the troll brothers and the turtles had put on their shoes, Carrot, Tomato and Blueberry went to collect their wooden truck with the black currant berries, and at last, with some delay, they brought the berries home flowed in small streams to Grandmother Snowberry. They were now clean, and happy, but droopingly wet. The water from them lay as small puddles on the kitchen on the below them as they at last entered the kitchen. Grandmother looked a bit firm at them, as they stood there dripping in front of her. ‘You took you time, my little wild friends,’ she said as she turned to her oven hiding a smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Can you understand, why it could sometimes take quite some time for the trolls to do their tasks?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("And how every task they did soon became a fun play?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Up in the blackbird’s nest, the birds had followed the trolls’ brothers’ adventures with giggles and smiles. They themselves also helped and contributed to the party by carrying cherries from the trees into Grandmother Snowberry’s kitchen. Now and then they took a little bite of them to check if they were ripe enough to serve for the guests.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The hedgehogs found small worms and larvae’s that they also brought to Grandmother for the party, but she said, that they could not go up on the table, but ought to be put in small baskets at the side of the table. That would look nice she said. Inside herself she was afraid that the worms and larvae might crawl up into the cakes. The last thing, about that they might crawl into the cake, she did not say loudly, to the hedgehogs. She did not want to hurt them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Cakes, berries, and nuts, and worm for somebody would be on the menu. To drink, the guests would be offered rhubarb and apple juice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then Cousin Cress came around and he offered to “air” the tattles while the other prepared other things. He also asked Grandmother if there were any other errands, she wished him to do. As usual he brought with him his parrot John. John added to the good atmosphere with his happy whistling as the turtles played on their instruments.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Grandmother padded Cress on his cheek and said, ‘No dear, Cress, you are such a kind and good grandson. Thank you for helping! I am sure the turtles will be happy for going to the Dandelion field.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("All of that was going on while everybody awaited the “Celebration Day Party”.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer055"
    }
  }, [_c('p', {
    staticClass: "Chapter-1-Heading ParaOverride-21",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("5. Cousin Cress, Why He Was")]), _vm._v(" "), _c('p', {
    staticClass: "heading-1 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Called That Name, and How He")])]), _vm._v(" "), _c('p', {
    staticClass: "heading-1 ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-13",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Aired the Turtles")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-14"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-37",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image075.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-23"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Cousin Cress in the dandelion field with the mini-turtles, He also brought coconut milk for them in the tow-truck. They smiled, giggled and one of them was dancing for joy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Cress wished to be helpful since he understood that his cousins and grandmother were all busy preparing for the party. So, he took the turtles out to their favourite dandelion field. Since he came frequently to the cousin’s tree he already knew about the party. So, now as he walked, he thought if he might carve a small toy, perhaps a sailboat to give to Blueberry as a celebration gift, at the party. He also knew that they used to share toys, so it could be a joy for them all, and afterwards they could go to the pond nearby and together sail with it. That could be fun, he thought. But first, he would take the turtles out for an excursion.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Dandelion leaves are a favourite dish for turtles, so that was why he chose that special place to take them. Inside the flower there is some milk like that they the turtles are especially fond of. Then they can get a little milk as well he thoughtfully was thinking.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Here, on the picture, you can see how the turtles enjoyed being with Cress and his parrot John. Cress liked their company. Cress had sometimes a little problem with John`s speech error now and then.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("He sighed a little whenever he corrected John. But he did so with a glimpse in his eyes, when John said HI, HI, when he instead meant AJ, AJ. He just wanted be kind. Then Cress said, ‘No, John, he said AJ, AJ, you see, he is in pain. It is  such a shame for him.’ So, Cress continued, ‘Please be quiet, John, so that the turtles can get a little peace. Soon they are going to eat.’ ‘Lovely day,’ John then said happily and whistled a bit. Cress always showed compassion and patience with John’s speech error. He meant that it was nothing that John could help, and Cress defended him away if he was mobbed or scolded for it. It is important always to show understanding for challenges that others have, smaller or bigger handicaps, and sometimes you cannot even see them, Cress meant.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Do you agree with Cress on this point of view?")])]), _vm._v(" "), _c('p', {
    staticClass: "mid-image-on-next-page-"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-38",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image077.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Above you see a Dandelion flower plant, and it’s long slim leaves, that the turtles liked so much. When the yellow flower has finished flowering it turn into seed and that is that cotton-like fluffy flower that you can also see on the picture.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Grown up people do mostly not like Dandelions on their grass lawn and often calls them weeds. But you see, in springtime they sometimes are the only flowers that bees can get their food from, so they can be very useful. Not to forget, their sunshine colour. To call a plant “weed” is perhaps not so kind, since they just sometimes grow on an unwanted place.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Do you also think that dandelion flowers look like small suns?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Is it nice to call something a weed?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Don’t we all have the right to live and grow?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("One can blow to the dandelion’s seed flower. Then the little seed then flies far away, like an insect and when they land, they can grow up to a new flower. They look so sweet when they lift and fly, and the trolls just loved to play “Dandelion-Airport” and go round blowing them off.  Then they said to each little flying seed,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘Have a nice flight little seed, and good luck, also in your new life!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Remember NEVER to eat anything from this plant! You are not a Turtle, are you?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Have you tried to blow to the Dandelions seeds flower?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Perhaps you have seen them fly in the wind just like a mosquito?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("NOT TO FORGET! We must remember to wash our hands whenever we have plucked Dandelion flowers, or we have played with their seed flowers. The plants juice is toxic for both humans and trolls. It is only turtles that can tolerate that. So, it is in life. We simply cannot all tolerate the same things.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("When cousin Cress got Parrott John")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Now you are going to hear about what happened when Cress got his parrot John. While the celebration preparation was on-going in the troll brothers’ olive tree and while all their friend awaited it with excitement.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("You also need to know that there was a rule among all the olive trolls’ family, that was when a young troll had grown so big, that it was time to move away from home, he or she was allowed to get a pet. No one wanted anyone to be lonely when they moved away from home. That is for everybody something of a change.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("One day, when Cress was walking by the marine. He saw a sailor coming towards him. The sailor was a sour type. He came walking as he was scolding on a little poor reed parrot, that he carried, in one of his hands, in a cage. ‘You are such a stupid bird. You cannot even speak clean. I tell you, you are so STUPID, I do not want to have you anymore. You have a speech error as well. Now, I go to the waste bin and throw you away, or maybe I will rather throw you in the harbour. I am sick and tired of you,’ the mad sailor shouted and swore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Cress saw how the little unhappy parrot was out of his mind from fear, and how its feathers were flying around inside the swinging cage, as tears ran down its cheeks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Cress rushed forward to the sailor and said, ‘But OH, hallow Mr Sailor, I mean, but no one can speak clean from the beginning, but usually that comes later.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The mad sailor sneered angrily, ‘Not this stupid bird. He learns just nothing. I wish to get rid of him NOW. Do you want him?’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Cress hurried to say, ‘OH! Yes please, thank you so much.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The sailor said, ‘Good to see  it that you get lost immediately, both of you!’ As he stamped his foot and raised his free fist threatening in front of Cress.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Rapidly, Cress took the cage from the sailor’s hand and rushed away with the swinging cage in his hand. He was afraid that the sailor would regret his offer. While he rushed breathless away, the cage struck his one leg. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("‘OF, OF!’, he shouted and stopped. Inside the cage the bird answered, DOF, DOF. Cress sat surprised down on his knees and opened the cage as he said, ‘So, that is it, you really have a speech error. That does not matter at all, my little friend.’ Then he padded the little bird on its feathered soft head and continued, ‘We all have some faults that do not mean that any of us must be thrown in the bin or in the harbour. So now, what shall we call you? Oh! now I remember a story about someone called “John all alone in the world, it is about the same with you”.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The little bird stopped crying and looked thankfully up at Cress and said, ‘Anks’ as he meant “thanks”.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Cress then said, ‘If you don’t fly away, you can sit on my shoulder, little John. Then you have a better view on the world. We can keep the cage open at home. Then you also will have an own room and a stich to sit on at night.’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Now, John sat comfortable on Cress shoulder and whistled a little happy melody, as the two new friends peacefully walked home to the family tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Home in the family tree, John was introduced to the whole family and after they had heard  the entire awful story about the mad sailor, John was heartily welcomed in the tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Later, there occurred  many speeches error occasions, but Cress came to love his bird and did not mind his disability, and John loved Cress back. He had saved his life and had also been given him a home.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("What do you think, is it fair to be thrown in the bin or in the harbour for something one cannot help?")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer057"
    }
  }, [_c('p', {
    staticClass: "Chapter-1-Heading",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("6. The Celebration Party and Minette-Mini-Mouse’s Whipped Cream Adventure")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then at last, came the day for Blueberry’s recovering party. The big party-cake was ready, and the table beautifully decorated with blue-checkered tablecloth and had blue- bows at the corners. The cage was in several floors. It was also decorated whipped cream, with chocolate icing and strawberry’s all around it. It looked so delicious and was placed on the middle of long decorated the table. The table stood in half shadow under a large tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Grandmother Snowberry arranged it nicely on the table and then Mr and Mrs Otto arrived as the first guests at the table and admired the cake.  Behind them came their three children. Minette the eldest of them was the last in their family group, standing behind the others. When she saw the cake, she got big eyes and her mouth watered. She thought, OH gosh, if I could only taste a little, little bit of that wonderful icing and just one lick of the whipped cream. I bet it has a taste of vanilla. Then her eyes caught the big branch hanging over the table from the huge tree behind.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then, she could not resist the impulse of arrowing behind her family.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Next, she rushed up the tree and then she slowly climbed on her stomach with a hard grip with her four paws out on the branch of the tree. I went quite well; she thought inside herself. She was quite long out the branch just over the cake- in a minute, she thought, she would be able to bend down and with one paw touch the cake. THEN it went all wrong. She started to glide, slowly glide.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("AND then she dived directly, with her headfirst, down")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("INTO the cake, like a swimmer from a bathing bridge!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("In the same moment, Dad Otto was looking up, and shocked saw how his daughter Minette Mini Mouse was falling, from the branch in the tree into the cake!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("WHAT! Otto shouted.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-14"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-39",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image079.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer062"
    }
  }, [_c('p', {
    staticClass: "_-txt"
  }, [_vm._v("The shocked parents seeing Minette falling into the cake. Poor Dad Otto is stretching his arms up in despair.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-17"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-15",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image081.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Se here come Minette’s Minicourse head up. Her mouth all open. She has whipped cream on her forehead and on her new reed bow. She was screaming!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("A minute passed, as everybody stood breathless, then she came up, through the whipped cream, with some of it, as a hat, on her reed bow, nose up, and then she screamed loudly with her mouth wide open:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("OH, NO, HELP!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("HELP, I am DROWNING! HELP!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Dad Otto turned SO mad, that he almost exploded, and he shouted:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("NAUGHTY; UNPOSSIBLY MOUSE! GET OUT OF THE CAKE IMMEDIATELY!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Minette answered Dad.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("SORRY, SORRY DAD BUT HOW?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Dad Otto shouted as loud as he ever could:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("SWIM; SWIM IN THE WHIPPED CREAM,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("YOU DUMMY, NAUGHTY MOUSE!")])]), _vm._v(" "), _c('p', {
    staticClass: "mid-image-on-next-page- ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-40",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image083.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("On this picture, you can see Dad Otto, still with lifting, wavering arms, Little Mum, and the envious sibling, looking all astonished up. And the situation got even worse when the younger siblings got jealous and called on to their dad.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("DAD, DAD, PLEASE COME AND LIFT US UP")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("WE ALSO WANT TO SWIM IN THE WHIPPED CREAM! PLEASE!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("NOW DADDY, WE CANNOT WAIT!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then dad Otto almost got a heart attack and shouted furiously, ‘Shut up’ kids or else…’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("AND now, Littlemother mouse also mixed herself up in the polemic,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("saying,‘But, Otto, please! mind you language! Please do NOT swear.Do not teach the children such bad language!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("You shock me Otto!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("really!’")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("At that point, Dad Otto Mouse almost fainted.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("In a minuted he just stood there all dizzy, then he rusched like a lightning up on the table, stretched himself in over the cake, and got hold of Minettes arms, and drew her out of the cake SPLASH!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("It sounded as both mice landed on the table. Many small splashings sound were thereafter heard by little feet, as they passed over the tablecloth and down from the table, looking like two snowmice. Otto by now also was all smeared in with the whipped cream.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("At that moment some very dear family members of the family three appeared out of the wood and could see the beautiful, decorated table, the huge cake and Minette’s diving directly into it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The surprised family came out of the wood and watched big eyed the mouse drama")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Grandmother Snowberry rushed foreword to greet them. She did not notice what was going on at the table. At first, she went up to her good friend Grandmother Sunshine and offered her a cake from her basket. Then at her side came Mum Candy floss with tears in her eyes as two of her son’s rushed foreword to her and their dad Viggo Licorice. Viggo had a bunch of roses for his mother. He wished to thank her for her help with Blueberry’s mood change. Blueberry, himself, had just turned round, and he saw how Minette fell. Then, Aunt Parsley and Mushroom appeared together with little cousin Thyme. That was of course Cress family. He just came back from his walk with the turtles. He smiled when he saw both his family and the entertainment at the table.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Blueberry was all out of himself for joy and offered all of them a blueberry from his basket, while he was laughing at it all. He thought it was mighty fun.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Now everybody went over to the pretty table AND THEN!!! They saw Minette coming up from the cake dressed in a whipped cream hat upon her read bow and they heard her scream of help.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("At first all the guests stood as frozen, and breathless, as they watched the scene of the mouse family drama. When they then saw how Minette was safe from drowning by her farther, that was the time where they all started to laugh, clapped their hands or paws, and started singing:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("  , BRUM, ZUM, ZUM HA, HA!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("What a circus. A real acrobat-show! They shouted and,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("OH, this was so much fun!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("HURRAY, HURRAY! For Blueberry’s recovering day!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("By now all the birds, the butterflies, the bees, Dr Owl and his wife, the hedgehog family, other friends, and more family members had arrived, even the new friends from the pond, the ducks stood at the end of the table and participated in all the fun, the singing, and the congratulations. Everybody had seen it all!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Even the turtles got a bit confused, so they played a couple of long fanfares to accompany the singing.  TUTTI-LUUUT! – TUTTI-LUUT!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("It became the best party atmosphere ever. The turtles played their instruments, and the blackbirds were whistling and so did John. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Would you have liked to have been there at the party?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("BUT!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Someone was not the least happy, and that was Dad Otto, the mouse. After the two-snow mouse-alike mice had left the table, he drew his daughter hard by the ear away from the party. The other mice family members came hastily after. Little Mum dragging the small siblings by each one hand after her. Minette was screaming like a little pig, but whenever a small click of the whipped cream fell of the two, in the front, the small mice hasted forward and “helpfully” licked it up. Inside them self they looked forward to, at home, help licking her clean.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("While the party now was full going, Minette was bathed and put to bed. Here she soon fell asleep dreaming about the beautiful cage. Just before she fell asleep, she thought regretfully that she did not have had time to really taste the cake. Also, she would have wished to have a big piece of it and would have wanted to participate in the dance. She just loved dancing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then, she still smiled in her sleep since she in her dream saw the cake.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The other two siblings were quite envious and sad since they felt they had been unfairly treated. Also, They thought that Minette had tastet it and said, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The miceparent, standing behind the bedroomdoor peaking in, well, they said. ‘Gosh! she is wild, but sweet!’ ‘It was a little pity for the small ones. Their fun was ruined, how can we make it up to them, and wonder what all the guests think about our family scandal today,’ they sighed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("But there came a surprise for them all the next day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("What do you think, was it still not a little bit pity for the mice sibling?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Can you guess what that surprise was?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Here comes the explanation!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Grandmother Snowberry’s comfort to the young mice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The next day, when the party was over, and everything had been cleaned up, Grandmother called the troll-brothers and said, ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("“do you know what sweet children, I believe that the young mice were very disappointed and sad yesterday since the missed the party. We, in our family always had the rule to help those who are sad and disappointed. Therefor I have packed a piece of cake to each of the members in the mouse family. Would you be so kind and go deliver the packages?”. ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The troll-brothers clapped their hands and jumped up and down, OH Yes, what a good idea Granny!”, said Tomato, Carrot and Blueberry, in each other’s mouth enthusiastically. Then they took the wooden truck and loaded it with the package’s and went singing on their way followed by the tattles sitting and making music at the end of the wagon")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Aunt Iris smiled as they passed her, and Uncle Pumpkin laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Higher up in the tree the doctor had heard the conversation and he commented to his wife,” ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Minettes whipped-cream accident added a lot to the good party-atmosphere. It seemed so well done. Like an arranged circus number. Even if it was an accident.")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("” He mumbled. Further he thought, but did not say, as he shook his head, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The brothers laughed so that their laughter sounded in the woods.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("When the troll train, with the wagon and the turtles to the mice’s mushroom, Carrot knocked on the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Who is there?!")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("”, it sounded from the inside")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("It`s us, the singing trolls, and we have a small gift from grandmother Snowberry")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("”, answered Tomato” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Dad Otto opened the door a little bit rechecked. He was embarrassed for his children")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Then Blueberry came forward with the basket. He bowed and said, “Thank you, so much that your children sat motion and fun in the part yesterday. That really lifted the atmosphere! It just became SO good!")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Having said that, the turtles played a loud fanfare to make it all even a little more festive")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Now, Little Mum and the young mice also peek forward. Then, Blueberry continued saying, “")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Please, a piece of the pattycake for each in the family as a thank you for your help!")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("”. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("After that he again bowed politely and the Tuttle-musician once more plaid a long and even louder fanfare.” ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Tutti-lute, tutti- luuut!!")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("It sounded.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The young mice went almost wild for joy, it was what they had dreamt About. They clapped their small paws and cheered and said,” ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("OH thank you ever so much, Dad Otto answered relieved. Please send my best regards to Grandmother Snowberry, she does really understand children. Have a nice walk home")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("”, he said, as he smilingly closed the door. All ended well, he thought. He sent a thankful thought to Grandmother Snowberry.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Do you also think that Grandmother Snowberry was good at understanding children?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("After the delivering, the troll brothers went home to their own tree. On their walk back they put the turtles in the truck and there they sat content playing and chatting with each other, and sometimes they played their instruments, and Tomato, Carrot and Blueberry sang “the Happy Song”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then Carrot turned to the tattles and praised them for their behavior at the mice’s door, having played such impressing fanfares at just the right times. “")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("It really made our visit much more festive, that was well done, you three. It made it so much more successful")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("”, he said. The turtles got proud, and happy for the praise, and they looked shy at each other getting pink in their checks. They smiled proudly and of poor joy the made a new fanfare. TRUUT! ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Do you think that it is important to praise someone for having been doing something well?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Do we all need to be prized sometimes")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("When they at last had arrived home, it was almost dark. In the kitchen cave Grandmother had cooked a good-smelling herb soup. When the had all been eating up and having had one of Granny’s small, sweet cakes for dessert. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("She looked lovingly at them and said,” ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("now my angels it is time for you to prepare for bed. Now toothbrushing, washing and nightcaps on. After that you can come back to Grandmother. Then I will read a “Good Night Story” to you. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("You know that Grandmother is going home to the family tree early tomorrow morning, and that you tree are going out playing. Therefore, we need a good night´s sleep")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("But now first, off you go!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The troll brothers stood up, looked at each other, and said with one voice,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("OK, who is first back? One-two-three- GO!")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("I will be first")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(", Tomato shouted")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("No, that will be me")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(", Carrot replied")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Not at all")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("that will be me")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(", shouted Blueberry")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Then they rushed laughing to each bathroom, very noisy indeed. The turtles saw to it, not to be in their way, in case they would stumble on them as the also giggled. ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("I bet my troll will be first, one said. No, that will be mine,")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" said the other. Then Sugar said, ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("not at all that will be Blueberry!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-24"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("I will share my coconut milk with you if he wins.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Grandmother Snowberry smiled as she shook her head. Then she said to herself, they never change these tree wildings, neither will their pets. Everything is fun and a competition. That is good. That makes life so much more merry and joyful. It would be good if everybody did so. Then she looked for a book to read to them. She could not find a new one, so instead she decided to make her own story. That story would be about three merry singing trolls in a big, wonderful wood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Do you remember to make all the daily routines to fun games?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Do you remember to enjoy everything you can?")])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-1-Heading",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("7. Evening in the Singing Troll’s Tree")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-25"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("After long days filled with plays, laughter and experiences you can get so, so tired. Then it is nice to go to bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-41",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image088.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-26"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Look, here is Blueberry asleep in his bed. He is smiling in his sleep, enjoying wearing Grandmother Sunshine’s knitted nightcap. He can feel Grandmother’s love in it. The other two brothers also used their nightcaps. They were all in different colours, nice, cosy and soft. Good to wear when it got chilly during the night. Under Blueberry’s bed, Sugar is all hidden. She slept beside her beloved night drink, the coconut milk.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I do not believe that you use a night cap,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Do you?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Before going to sleep the brothers always shouted “Good Night” to each other followed by a teasing, friendly rhyme.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Good night, good night")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("You little wimp,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Tomorrow it is a new “playing turn”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("I will be first up,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("With energy on top,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("I will be the strongest one")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("The others replied,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("No, I will!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("No, I will!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Well, we will see,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Nighty, nighty")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("They giggled and fell all fast asleep. They did not think it was anything unnatural becoming dull and wimpy after a long day with lots of play and activities. Then it was wonderful to go to bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Do you also think it is OK to become a little dull and wimpy after a long day?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Now it is evening. The trolls are snoring in their beds with their pets underneath.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("It is also time for you to go to bed, little friend!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Good night to you!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Cuddle now under your blanket, and enjoy you sleep!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-14"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-42",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/image085.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("On this picture you can see all the colourful troll Family, note the troll-brothers sweet parents: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-27"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Dad Viggo Licorice and")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" Mom Candy Floss, aunt Parley, uncle Mushrum and not least little cousin Thyme.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("The entire troll’s family wave you Good Night, and Good Bye!")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer063"
    }
  }, [_c('p', {
    staticClass: "_-txt"
  }, [_c('span', {
    staticClass: "CharOverride-15"
  }, [_vm._v("On this page, please draw one of the trolls that you remember the best from the book")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer064"
    }
  }, [_c('p', {
    staticClass: "_-txt"
  }, [_c('span', {
    staticClass: "CharOverride-15"
  }, [_vm._v("One this page, please draw yourself and perhaps you also can write your age.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer065"
    }
  }, [_c('p', {
    staticClass: "_-txt"
  }, [_c('span', {
    staticClass: "CharOverride-15"
  }, [_vm._v("On this page, you are allowed to draw a picture that you liked the best from the book")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer066"
    }
  }, [_c('p', {
    staticClass: "_ ParaOverride-6",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("8. Afterword")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("The pictures/collages were made/draw/painted by the author herself and the photos taken by an iPhone eight camera, except from the flying owl and Dr Owl’s praxis. The flying owl was taken by Leif Sorensen, Fyn, Denmark, and the owl’s praxis was contributed by my friend: Dr Bjarne Hansen, Malmoe, Sweden.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-28"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Thank you both!")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer067"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer068"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer069"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer070"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer071"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer072"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer073"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer074"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer075"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer076"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer077"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer078"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f63e1502","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781035835195_Epub.vue
// module id = 57
// module chunks = 0